(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebaaf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebaaf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2BGKp", function(module, exports) {

$parcel$export(module.exports, "FrameLoadingStyle", function () { return FrameLoadingStyle; });
$parcel$export(module.exports, "FrameElement", function () { return FrameElement; });
$parcel$export(module.exports, "FrameRenderer", function () { return FrameRenderer; });
$parcel$export(module.exports, "PageSnapshot", function () { return PageSnapshot; });
$parcel$export(module.exports, "PageRenderer", function () { return PageRenderer; });
$parcel$export(module.exports, "StreamActions", function () { return StreamActions; });
$parcel$export(module.exports, "session", function () { return session; });
$parcel$export(module.exports, "cache", function () { return cache; });
$parcel$export(module.exports, "navigator", function () { return navigator$1; });
$parcel$export(module.exports, "start", function () { return start; });
$parcel$export(module.exports, "registerAdapter", function () { return registerAdapter; });
$parcel$export(module.exports, "visit", function () { return visit; });
$parcel$export(module.exports, "connectStreamSource", function () { return connectStreamSource; });
$parcel$export(module.exports, "disconnectStreamSource", function () { return disconnectStreamSource; });
$parcel$export(module.exports, "renderStreamMessage", function () { return renderStreamMessage; });
$parcel$export(module.exports, "clearCache", function () { return clearCache; });
$parcel$export(module.exports, "setProgressBarDelay", function () { return setProgressBarDelay; });
$parcel$export(module.exports, "setConfirmMethod", function () { return setConfirmMethod; });
$parcel$export(module.exports, "setFormMode", function () { return setFormMode; });
$parcel$export(module.exports, "StreamElement", function () { return StreamElement; });
$parcel$export(module.exports, "StreamSourceElement", function () { return StreamSourceElement; });

var $feAea = parcelRequire("feAea");

var $jpnpo = parcelRequire("jpnpo");

var $9j09T = parcelRequire("9j09T");

var $eDeHT = parcelRequire("eDeHT");

var $Npnks = parcelRequire("Npnks");

var $15W2b = parcelRequire("15W2b");

var $711He = parcelRequire("711He");

var $i0LXg = parcelRequire("i0LXg");

var $fyOZQ = parcelRequire("fyOZQ");

var $aqIdE = parcelRequire("aqIdE");

var $enL5v = parcelRequire("enL5v");

var $fYvNR = parcelRequire("fYvNR");

var $a1vXf = parcelRequire("a1vXf");

var $itJXR = parcelRequire("itJXR");
function _templateObject() {
    var data = (0, $aqIdE._)([
        "\n      .turbo-progress-bar {\n        position: fixed;\n        display: block;\n        top: 0;\n        left: 0;\n        height: 3px;\n        background: #0076ff;\n        z-index: 2147483647;\n        transition:\n          width ",
        "ms ease-out,\n          opacity ",
        "ms ",
        "ms ease-in;\n        transform: translate3d(0, 0, 0);\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0, $aqIdE._)([
        '\n        You are loading Turbo from a <script> element inside the <body> element. This is probably not what you meant to do!\n\n        Load your application\u2019s JavaScript bundle inside the <head> element instead. <script> elements in <body> are evaluated with each page change.\n\n        For more information, see: https://turbo.hotwired.dev/handbook/building#working-with-script-elements\n\n        \u2014\u2014\n        Suppress this warning by adding a "data-turbo-suppress-warning" attribute to: %s\n      '
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
/*
Turbo 7.3.0
Copyright © 2023 37signals LLC
 */ (function() {
    if (window.Reflect === undefined || window.customElements === undefined || window.customElements.polyfillWrapFlushCallback) return;
    var BuiltInHTMLElement = HTMLElement;
    var wrapperForTheName = {
        HTMLElement: function HTMLElement1() {
            return Reflect.construct(BuiltInHTMLElement, [], this.constructor);
        }
    };
    window.HTMLElement = wrapperForTheName["HTMLElement"];
    HTMLElement.prototype = BuiltInHTMLElement.prototype;
    HTMLElement.prototype.constructor = HTMLElement;
    Object.setPrototypeOf(HTMLElement, BuiltInHTMLElement);
})();
/**
 * The MIT License (MIT)
 * 
 * Copyright (c) 2019 Javan Makhmali
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ (function(prototype) {
    if (typeof prototype.requestSubmit == "function") return;
    prototype.requestSubmit = function(submitter) {
        if (submitter) {
            validateSubmitter(submitter, this);
            submitter.click();
        } else {
            submitter = document.createElement("input");
            submitter.type = "submit";
            submitter.hidden = true;
            this.appendChild(submitter);
            submitter.click();
            this.removeChild(submitter);
        }
    };
    function validateSubmitter(submitter, form) {
        submitter instanceof HTMLElement || raise(TypeError, "parameter 1 is not of type 'HTMLElement'");
        submitter.type == "submit" || raise(TypeError, "The specified element is not a submit button");
        submitter.form == form || raise(DOMException, "The specified element is not owned by this form element", "NotFoundError");
    }
    function raise(errorConstructor, message, name) {
        throw new errorConstructor("Failed to execute 'requestSubmit' on 'HTMLFormElement': " + message + ".", name);
    }
})(HTMLFormElement.prototype);
var submittersByForm = new WeakMap();
function findSubmitterFromClickTarget(target) {
    var element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
    var candidate = element ? element.closest("input, button") : null;
    return (candidate === null || candidate === void 0 ? void 0 : candidate.type) == "submit" ? candidate : null;
}
function clickCaptured(event) {
    var submitter = findSubmitterFromClickTarget(event.target);
    if (submitter && submitter.form) submittersByForm.set(submitter.form, submitter);
}
(function() {
    if ("submitter" in Event.prototype) return;
    var prototype = window.Event.prototype;
    if ("SubmitEvent" in window && /Apple Computer/.test(navigator.vendor)) prototype = window.SubmitEvent.prototype;
    else if ("SubmitEvent" in window) return;
    addEventListener("click", clickCaptured, true);
    Object.defineProperty(prototype, "submitter", {
        get: function() {
            if (this.type == "submit" && this.target instanceof HTMLFormElement) return submittersByForm.get(this.target);
        }
    });
})();
var FrameLoadingStyle;
(function(FrameLoadingStyle) {
    FrameLoadingStyle["eager"] = "eager";
    FrameLoadingStyle["lazy"] = "lazy";
})(FrameLoadingStyle || (FrameLoadingStyle = {}));
var FrameElement = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $i0LXg._)(FrameElement, HTMLElement1);
    var _super = (0, $a1vXf._)(FrameElement);
    function FrameElement() {
        (0, $9j09T._)(this, FrameElement);
        var _this;
        _this = _super.call(this);
        _this.loaded = Promise.resolve();
        _this.delegate = new FrameElement.delegateConstructor((0, $feAea._)(_this));
        return _this;
    }
    (0, $eDeHT._)(FrameElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                this.delegate.connect();
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                this.delegate.disconnect();
            }
        },
        {
            key: "reload",
            value: function reload() {
                return this.delegate.sourceURLReloaded();
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(name) {
                if (name == "loading") this.delegate.loadingStyleChanged();
                else if (name == "complete") this.delegate.completeChanged();
                else if (name == "src") this.delegate.sourceURLChanged();
                else this.delegate.disabledChanged();
            }
        },
        {
            key: "src",
            get: function get() {
                return this.getAttribute("src");
            },
            set: function set(value) {
                if (value) this.setAttribute("src", value);
                else this.removeAttribute("src");
            }
        },
        {
            key: "loading",
            get: function get() {
                return frameLoadingStyleFromString(this.getAttribute("loading") || "");
            },
            set: function set(value) {
                if (value) this.setAttribute("loading", value);
                else this.removeAttribute("loading");
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this.hasAttribute("disabled");
            },
            set: function set(value) {
                if (value) this.setAttribute("disabled", "");
                else this.removeAttribute("disabled");
            }
        },
        {
            key: "autoscroll",
            get: function get() {
                return this.hasAttribute("autoscroll");
            },
            set: function set(value) {
                if (value) this.setAttribute("autoscroll", "");
                else this.removeAttribute("autoscroll");
            }
        },
        {
            key: "complete",
            get: function get() {
                return !this.delegate.isLoading;
            }
        },
        {
            key: "isActive",
            get: function get() {
                return this.ownerDocument === document && !this.isPreview;
            }
        },
        {
            key: "isPreview",
            get: function get() {
                var _a, _b;
                return (_b = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.documentElement) === null || _b === void 0 ? void 0 : _b.hasAttribute("data-turbo-preview");
            }
        }
    ], [
        {
            key: "observedAttributes",
            get: function get() {
                return [
                    "disabled",
                    "complete",
                    "loading",
                    "src"
                ];
            }
        }
    ]);
    return FrameElement;
}((0, $fYvNR._)(HTMLElement));
function frameLoadingStyleFromString(style) {
    switch(style.toLowerCase()){
        case "lazy":
            return FrameLoadingStyle.lazy;
        default:
            return FrameLoadingStyle.eager;
    }
}
function expandURL(locatable) {
    return new URL(locatable.toString(), document.baseURI);
}
function getAnchor(url) {
    var anchorMatch;
    if (url.hash) return url.hash.slice(1);
    else if (anchorMatch = url.href.match(/#(.*)$/)) return anchorMatch[1];
}
function getAction(form, submitter) {
    var action = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formaction")) || form.getAttribute("action") || form.action;
    return expandURL(action);
}
function getExtension(url) {
    return (getLastPathComponent(url).match(/\.[^.]*$/) || [])[0] || "";
}
function isHTML(url) {
    return !!getExtension(url).match(/^(?:|\.(?:htm|html|xhtml|php))$/);
}
function isPrefixedBy(baseURL, url) {
    var prefix = getPrefix(url);
    return baseURL.href === expandURL(prefix).href || baseURL.href.startsWith(prefix);
}
function locationIsVisitable(location1, rootLocation) {
    return isPrefixedBy(location1, rootLocation) && isHTML(location1);
}
function getRequestURL(url) {
    var anchor = getAnchor(url);
    return anchor != null ? url.href.slice(0, -(anchor.length + 1)) : url.href;
}
function toCacheKey(url) {
    return getRequestURL(url);
}
function urlsAreEqual(left, right) {
    return expandURL(left).href == expandURL(right).href;
}
function getPathComponents(url) {
    return url.pathname.split("/").slice(1);
}
function getLastPathComponent(url) {
    return getPathComponents(url).slice(-1)[0];
}
function getPrefix(url) {
    return addTrailingSlash(url.origin + url.pathname);
}
function addTrailingSlash(value) {
    return value.endsWith("/") ? value : value + "/";
}
var FetchResponse = /*#__PURE__*/ function() {
    "use strict";
    function FetchResponse(response) {
        (0, $9j09T._)(this, FetchResponse);
        this.response = response;
    }
    (0, $eDeHT._)(FetchResponse, [
        {
            key: "succeeded",
            get: function get() {
                return this.response.ok;
            }
        },
        {
            key: "failed",
            get: function get() {
                return !this.succeeded;
            }
        },
        {
            key: "clientError",
            get: function get() {
                return this.statusCode >= 400 && this.statusCode <= 499;
            }
        },
        {
            key: "serverError",
            get: function get() {
                return this.statusCode >= 500 && this.statusCode <= 599;
            }
        },
        {
            key: "redirected",
            get: function get() {
                return this.response.redirected;
            }
        },
        {
            key: "location",
            get: function get() {
                return expandURL(this.response.url);
            }
        },
        {
            key: "isHTML",
            get: function get() {
                return this.contentType && this.contentType.match(/^(?:text\/([^\s;,]+\b)?html|application\/xhtml\+xml)\b/);
            }
        },
        {
            key: "statusCode",
            get: function get() {
                return this.response.status;
            }
        },
        {
            key: "contentType",
            get: function get() {
                return this.header("Content-Type");
            }
        },
        {
            key: "responseText",
            get: function get() {
                return this.response.clone().text();
            }
        },
        {
            key: "responseHTML",
            get: function get() {
                if (this.isHTML) return this.response.clone().text();
                else return Promise.resolve(undefined);
            }
        },
        {
            key: "header",
            value: function header(name) {
                return this.response.headers.get(name);
            }
        }
    ]);
    return FetchResponse;
}();
function activateScriptElement(element) {
    if (element.getAttribute("data-turbo-eval") == "false") return element;
    else {
        var createdScriptElement = document.createElement("script");
        var cspNonce = getMetaContent("csp-nonce");
        if (cspNonce) createdScriptElement.nonce = cspNonce;
        createdScriptElement.textContent = element.textContent;
        createdScriptElement.async = false;
        copyElementAttributes(createdScriptElement, element);
        return createdScriptElement;
    }
}
function copyElementAttributes(destinationElement, sourceElement) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sourceElement.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
            destinationElement.setAttribute(name, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function createDocumentFragment(html) {
    var template = document.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function dispatch(eventName) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, cancelable = _ref.cancelable, detail = _ref.detail;
    var event = new CustomEvent(eventName, {
        cancelable: cancelable,
        bubbles: true,
        composed: true,
        detail: detail
    });
    if (target && target.isConnected) target.dispatchEvent(event);
    else document.documentElement.dispatchEvent(event);
    return event;
}
function nextAnimationFrame() {
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            return resolve();
        });
    });
}
function nextEventLoopTick() {
    return new Promise(function(resolve) {
        return setTimeout(function() {
            return resolve();
        }, 0);
    });
}
function nextMicrotask() {
    return Promise.resolve();
}
function parseHTMLDocument() {
    var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new DOMParser().parseFromString(html, "text/html");
}
function unindent(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    var lines = interpolate(strings, values).replace(/^\n/, "").split("\n");
    var match = lines[0].match(/^\s+/);
    var indent = match ? match[0].length : 0;
    return lines.map(function(line) {
        return line.slice(indent);
    }).join("\n");
}
function interpolate(strings, values) {
    return strings.reduce(function(result, string, i) {
        var value = values[i] == undefined ? "" : values[i];
        return result + string + value;
    }, "");
}
function uuid() {
    return Array.from({
        length: 36
    }).map(function(_, i) {
        if (i == 8 || i == 13 || i == 18 || i == 23) return "-";
        else if (i == 14) return "4";
        else if (i == 19) return (Math.floor(Math.random() * 4) + 8).toString(16);
        else return Math.floor(Math.random() * 15).toString(16);
    }).join("");
}
function getAttribute(attributeName) {
    for(var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        elements[_key - 1] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements.map(function(element) {
            return element === null || element === void 0 ? void 0 : element.getAttribute(attributeName);
        })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (typeof value == "string") return value;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function hasAttribute(attributeName) {
    for(var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        elements[_key - 1] = arguments[_key];
    }
    return elements.some(function(element) {
        return element && element.hasAttribute(attributeName);
    });
}
function markAsBusy() {
    for(var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++){
        elements[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (element.localName == "turbo-frame") element.setAttribute("busy", "");
            element.setAttribute("aria-busy", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function clearBusyState() {
    for(var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++){
        elements[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (element.localName == "turbo-frame") element.removeAttribute("busy");
            element.removeAttribute("aria-busy");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function waitForLoad(element) {
    var timeoutInMilliseconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    return new Promise(function(resolve) {
        var onComplete = function() {
            element.removeEventListener("error", onComplete);
            element.removeEventListener("load", onComplete);
            resolve();
        };
        element.addEventListener("load", onComplete, {
            once: true
        });
        element.addEventListener("error", onComplete, {
            once: true
        });
        setTimeout(resolve, timeoutInMilliseconds);
    });
}
function getHistoryMethodForAction(action) {
    switch(action){
        case "replace":
            return history.replaceState;
        case "advance":
        case "restore":
            return history.pushState;
    }
}
function isAction(action) {
    return action == "advance" || action == "replace" || action == "restore";
}
function getVisitAction() {
    for(var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++){
        elements[_key] = arguments[_key];
    }
    var action = getAttribute.apply(void 0, [
        "data-turbo-action"
    ].concat((0, $enL5v._)(elements)));
    return isAction(action) ? action : null;
}
function getMetaElement(name) {
    return document.querySelector('meta[name="'.concat(name, '"]'));
}
function getMetaContent(name) {
    var element = getMetaElement(name);
    return element && element.content;
}
function setMetaContent(name, content) {
    var element = getMetaElement(name);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute("name", name);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
    return element;
}
function findClosestRecursively(element, selector) {
    var _a;
    if (element instanceof Element) return element.closest(selector) || findClosestRecursively(element.assignedSlot || ((_a = element.getRootNode()) === null || _a === void 0 ? void 0 : _a.host), selector);
}
var FetchMethod;
(function(FetchMethod) {
    FetchMethod[FetchMethod["get"] = 0] = "get";
    FetchMethod[FetchMethod["post"] = 1] = "post";
    FetchMethod[FetchMethod["put"] = 2] = "put";
    FetchMethod[FetchMethod["patch"] = 3] = "patch";
    FetchMethod[FetchMethod["delete"] = 4] = "delete";
})(FetchMethod || (FetchMethod = {}));
function fetchMethodFromString(method) {
    switch(method.toLowerCase()){
        case "get":
            return FetchMethod.get;
        case "post":
            return FetchMethod.post;
        case "put":
            return FetchMethod.put;
        case "patch":
            return FetchMethod.patch;
        case "delete":
            return FetchMethod.delete;
    }
}
var FetchRequest = /*#__PURE__*/ function() {
    "use strict";
    function FetchRequest(delegate, method, location1) {
        var body = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new URLSearchParams(), target = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        (0, $9j09T._)(this, FetchRequest);
        this.abortController = new AbortController();
        this.resolveRequestPromise = function(_value) {};
        this.delegate = delegate;
        this.method = method;
        this.headers = this.defaultHeaders;
        this.body = body;
        this.url = location1;
        this.target = target;
    }
    (0, $eDeHT._)(FetchRequest, [
        {
            key: "location",
            get: function get() {
                return this.url;
            }
        },
        {
            key: "params",
            get: function get() {
                return this.url.searchParams;
            }
        },
        {
            key: "entries",
            get: function get() {
                return this.body ? Array.from(this.body.entries()) : [];
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.abortController.abort();
            }
        },
        {
            key: "perform",
            value: function perform() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var fetchOptions, response, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fetchOptions = _this.fetchOptions;
                                _this.delegate.prepareRequest(_this);
                                return [
                                    4,
                                    _this.allowRequestToBeIntercepted(fetchOptions)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    6,
                                    7
                                ]);
                                _this.delegate.requestStarted(_this);
                                return [
                                    4,
                                    fetch(_this.url.href, fetchOptions)
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    4,
                                    _this.receive(response)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                error = _state.sent();
                                if (error.name !== "AbortError") {
                                    if (_this.willDelegateErrorHandling(error)) _this.delegate.requestErrored(_this, error);
                                    throw error;
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _this.delegate.requestFinished(_this);
                                return [
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "receive",
            value: function receive(response) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var fetchResponse, event;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        fetchResponse = new FetchResponse(response);
                        event = dispatch("turbo:before-fetch-response", {
                            cancelable: true,
                            detail: {
                                fetchResponse: fetchResponse
                            },
                            target: _this.target
                        });
                        if (event.defaultPrevented) _this.delegate.requestPreventedHandlingResponse(_this, fetchResponse);
                        else if (fetchResponse.succeeded) _this.delegate.requestSucceededWithResponse(_this, fetchResponse);
                        else _this.delegate.requestFailedWithResponse(_this, fetchResponse);
                        return [
                            2,
                            fetchResponse
                        ];
                    });
                })();
            }
        },
        {
            key: "fetchOptions",
            get: function get() {
                var _a;
                return {
                    method: FetchMethod[this.method].toUpperCase(),
                    credentials: "same-origin",
                    headers: this.headers,
                    redirect: "follow",
                    body: this.isSafe ? null : this.body,
                    signal: this.abortSignal,
                    referrer: (_a = this.delegate.referrer) === null || _a === void 0 ? void 0 : _a.href
                };
            }
        },
        {
            key: "defaultHeaders",
            get: function get() {
                return {
                    Accept: "text/html, application/xhtml+xml"
                };
            }
        },
        {
            key: "isSafe",
            get: function get() {
                return this.method === FetchMethod.get;
            }
        },
        {
            key: "abortSignal",
            get: function get() {
                return this.abortController.signal;
            }
        },
        {
            key: "acceptResponseType",
            value: function acceptResponseType(mimeType) {
                this.headers["Accept"] = [
                    mimeType,
                    this.headers["Accept"]
                ].join(", ");
            }
        },
        {
            key: "allowRequestToBeIntercepted",
            value: function allowRequestToBeIntercepted(fetchOptions) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var requestInterception, event;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                requestInterception = new Promise(function(resolve) {
                                    return _this.resolveRequestPromise = resolve;
                                });
                                event = dispatch("turbo:before-fetch-request", {
                                    cancelable: true,
                                    detail: {
                                        fetchOptions: fetchOptions,
                                        url: _this.url,
                                        resume: _this.resolveRequestPromise
                                    },
                                    target: _this.target
                                });
                                if (!event.defaultPrevented) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    requestInterception
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "willDelegateErrorHandling",
            value: function willDelegateErrorHandling(error) {
                var event = dispatch("turbo:fetch-request-error", {
                    target: this.target,
                    cancelable: true,
                    detail: {
                        request: this,
                        error: error
                    }
                });
                return !event.defaultPrevented;
            }
        }
    ]);
    return FetchRequest;
}();
var AppearanceObserver = /*#__PURE__*/ function() {
    "use strict";
    function AppearanceObserver(delegate, element) {
        var _this = this;
        (0, $9j09T._)(this, AppearanceObserver);
        this.started = false;
        this.intersect = function(entries) {
            var lastEntry = entries.slice(-1)[0];
            if (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.isIntersecting) _this.delegate.elementAppearedInViewport(_this.element);
        };
        this.delegate = delegate;
        this.element = element;
        this.intersectionObserver = new IntersectionObserver(this.intersect);
    }
    (0, $eDeHT._)(AppearanceObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.intersectionObserver.observe(this.element);
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.intersectionObserver.unobserve(this.element);
                }
            }
        }
    ]);
    return AppearanceObserver;
}();
var StreamMessage = /*#__PURE__*/ function() {
    "use strict";
    function StreamMessage(fragment) {
        (0, $9j09T._)(this, StreamMessage);
        this.fragment = importStreamElements(fragment);
    }
    (0, $eDeHT._)(StreamMessage, null, [
        {
            key: "wrap",
            value: function wrap(message) {
                if (typeof message == "string") return new this(createDocumentFragment(message));
                else return message;
            }
        }
    ]);
    return StreamMessage;
}();
StreamMessage.contentType = "text/vnd.turbo-stream.html";
function importStreamElements(fragment) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = fragment.querySelectorAll("turbo-stream")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var streamElement = document.importNode(element, true);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = streamElement.templateElement.content.querySelectorAll("script")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var inertScriptElement = _step1.value;
                    inertScriptElement.replaceWith(activateScriptElement(inertScriptElement));
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            element.replaceWith(streamElement);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return fragment;
}
var FormSubmissionState;
(function(FormSubmissionState) {
    FormSubmissionState[FormSubmissionState["initialized"] = 0] = "initialized";
    FormSubmissionState[FormSubmissionState["requesting"] = 1] = "requesting";
    FormSubmissionState[FormSubmissionState["waiting"] = 2] = "waiting";
    FormSubmissionState[FormSubmissionState["receiving"] = 3] = "receiving";
    FormSubmissionState[FormSubmissionState["stopping"] = 4] = "stopping";
    FormSubmissionState[FormSubmissionState["stopped"] = 5] = "stopped";
})(FormSubmissionState || (FormSubmissionState = {}));
var FormEnctype;
(function(FormEnctype) {
    FormEnctype["urlEncoded"] = "application/x-www-form-urlencoded";
    FormEnctype["multipart"] = "multipart/form-data";
    FormEnctype["plain"] = "text/plain";
})(FormEnctype || (FormEnctype = {}));
function formEnctypeFromString(encoding) {
    switch(encoding.toLowerCase()){
        case FormEnctype.multipart:
            return FormEnctype.multipart;
        case FormEnctype.plain:
            return FormEnctype.plain;
        default:
            return FormEnctype.urlEncoded;
    }
}
var FormSubmission = /*#__PURE__*/ function() {
    "use strict";
    function FormSubmission(delegate, formElement, submitter) {
        var mustRedirect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        (0, $9j09T._)(this, FormSubmission);
        this.state = FormSubmissionState.initialized;
        this.delegate = delegate;
        this.formElement = formElement;
        this.submitter = submitter;
        this.formData = buildFormData(formElement, submitter);
        this.location = expandURL(this.action);
        if (this.method == FetchMethod.get) mergeFormDataEntries(this.location, (0, $enL5v._)(this.body.entries()));
        this.fetchRequest = new FetchRequest(this, this.method, this.location, this.body, this.formElement);
        this.mustRedirect = mustRedirect;
    }
    (0, $eDeHT._)(FormSubmission, [
        {
            key: "method",
            get: function get() {
                var _a;
                var method = ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formmethod")) || this.formElement.getAttribute("method") || "";
                return fetchMethodFromString(method.toLowerCase()) || FetchMethod.get;
            }
        },
        {
            key: "action",
            get: function get() {
                var _a;
                var formElementAction = typeof this.formElement.action === "string" ? this.formElement.action : null;
                if ((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.hasAttribute("formaction")) return this.submitter.getAttribute("formaction") || "";
                else return this.formElement.getAttribute("action") || formElementAction || "";
            }
        },
        {
            key: "body",
            get: function get() {
                if (this.enctype == FormEnctype.urlEncoded || this.method == FetchMethod.get) return new URLSearchParams(this.stringFormData);
                else return this.formData;
            }
        },
        {
            key: "enctype",
            get: function get() {
                var _a;
                return formEnctypeFromString(((_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("formenctype")) || this.formElement.enctype);
            }
        },
        {
            key: "isSafe",
            get: function get() {
                return this.fetchRequest.isSafe;
            }
        },
        {
            key: "stringFormData",
            get: function get() {
                return (0, $enL5v._)(this.formData).reduce(function(entries, param) {
                    var _param = (0, $fyOZQ._)(param, 2), name = _param[0], value = _param[1];
                    return entries.concat(typeof value == "string" ? [
                        [
                            name,
                            value
                        ]
                    ] : []);
                }, []);
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var initialized, requesting, confirmationMessage, answer;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                initialized = FormSubmissionState.initialized, requesting = FormSubmissionState.requesting;
                                confirmationMessage = getAttribute("data-turbo-confirm", _this.submitter, _this.formElement);
                                if (!(typeof confirmationMessage === "string")) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    FormSubmission.confirmMethod(confirmationMessage, _this.formElement, _this.submitter)
                                ];
                            case 1:
                                answer = _state.sent();
                                if (!answer) return [
                                    2
                                ];
                                _state.label = 2;
                            case 2:
                                if (_this.state == initialized) {
                                    _this.state = requesting;
                                    return [
                                        2,
                                        _this.fetchRequest.perform()
                                    ];
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopping = FormSubmissionState.stopping, stopped = FormSubmissionState.stopped;
                if (this.state != stopping && this.state != stopped) {
                    this.state = stopping;
                    this.fetchRequest.cancel();
                    return true;
                }
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(request) {
                if (!request.isSafe) {
                    var token = getCookieValue(getMetaContent("csrf-param")) || getMetaContent("csrf-token");
                    if (token) request.headers["X-CSRF-Token"] = token;
                }
                if (this.requestAcceptsTurboStreamResponse(request)) request.acceptResponseType(StreamMessage.contentType);
            }
        },
        {
            key: "requestStarted",
            value: function requestStarted(_request) {
                var _a;
                this.state = FormSubmissionState.waiting;
                (_a = this.submitter) === null || _a === void 0 || _a.setAttribute("disabled", "");
                this.setSubmitsWith();
                dispatch("turbo:submit-start", {
                    target: this.formElement,
                    detail: {
                        formSubmission: this
                    }
                });
                this.delegate.formSubmissionStarted(this);
            }
        },
        {
            key: "requestPreventedHandlingResponse",
            value: function requestPreventedHandlingResponse(request, response) {
                this.result = {
                    success: response.succeeded,
                    fetchResponse: response
                };
            }
        },
        {
            key: "requestSucceededWithResponse",
            value: function requestSucceededWithResponse(request, response) {
                if (response.clientError || response.serverError) this.delegate.formSubmissionFailedWithResponse(this, response);
                else if (this.requestMustRedirect(request) && responseSucceededWithoutRedirect(response)) {
                    var error = new Error("Form responses must redirect to another location");
                    this.delegate.formSubmissionErrored(this, error);
                } else {
                    this.state = FormSubmissionState.receiving;
                    this.result = {
                        success: true,
                        fetchResponse: response
                    };
                    this.delegate.formSubmissionSucceededWithResponse(this, response);
                }
            }
        },
        {
            key: "requestFailedWithResponse",
            value: function requestFailedWithResponse(request, response) {
                this.result = {
                    success: false,
                    fetchResponse: response
                };
                this.delegate.formSubmissionFailedWithResponse(this, response);
            }
        },
        {
            key: "requestErrored",
            value: function requestErrored(request, error) {
                this.result = {
                    success: false,
                    error: error
                };
                this.delegate.formSubmissionErrored(this, error);
            }
        },
        {
            key: "requestFinished",
            value: function requestFinished(_request) {
                var _a;
                this.state = FormSubmissionState.stopped;
                (_a = this.submitter) === null || _a === void 0 || _a.removeAttribute("disabled");
                this.resetSubmitterText();
                dispatch("turbo:submit-end", {
                    target: this.formElement,
                    detail: Object.assign({
                        formSubmission: this
                    }, this.result)
                });
                this.delegate.formSubmissionFinished(this);
            }
        },
        {
            key: "setSubmitsWith",
            value: function setSubmitsWith() {
                if (!this.submitter || !this.submitsWith) return;
                if (this.submitter.matches("button")) {
                    this.originalSubmitText = this.submitter.innerHTML;
                    this.submitter.innerHTML = this.submitsWith;
                } else if (this.submitter.matches("input")) {
                    var input = this.submitter;
                    this.originalSubmitText = input.value;
                    input.value = this.submitsWith;
                }
            }
        },
        {
            key: "resetSubmitterText",
            value: function resetSubmitterText() {
                if (!this.submitter || !this.originalSubmitText) return;
                if (this.submitter.matches("button")) this.submitter.innerHTML = this.originalSubmitText;
                else if (this.submitter.matches("input")) {
                    var input = this.submitter;
                    input.value = this.originalSubmitText;
                }
            }
        },
        {
            key: "requestMustRedirect",
            value: function requestMustRedirect(request) {
                return !request.isSafe && this.mustRedirect;
            }
        },
        {
            key: "requestAcceptsTurboStreamResponse",
            value: function requestAcceptsTurboStreamResponse(request) {
                return !request.isSafe || hasAttribute("data-turbo-stream", this.submitter, this.formElement);
            }
        },
        {
            key: "submitsWith",
            get: function get() {
                var _a;
                return (_a = this.submitter) === null || _a === void 0 ? void 0 : _a.getAttribute("data-turbo-submits-with");
            }
        }
    ], [
        {
            key: "confirmMethod",
            value: function confirmMethod(message, _element, _submitter) {
                return Promise.resolve(confirm(message));
            }
        }
    ]);
    return FormSubmission;
}();
function buildFormData(formElement, submitter) {
    var formData = new FormData(formElement);
    var name = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("name");
    var value = submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("value");
    if (name) formData.append(name, value || "");
    return formData;
}
function getCookieValue(cookieName) {
    if (cookieName != null) {
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        var cookie = cookies.find(function(cookie) {
            return cookie.startsWith(cookieName);
        });
        if (cookie) {
            var value = cookie.split("=").slice(1).join("=");
            return value ? decodeURIComponent(value) : undefined;
        }
    }
}
function responseSucceededWithoutRedirect(response) {
    return response.statusCode == 200 && !response.redirected;
}
function mergeFormDataEntries(url, entries) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $fyOZQ._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
            if (value instanceof File) continue;
            searchParams.append(name, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    url.search = searchParams.toString();
    return url;
}
var Snapshot = /*#__PURE__*/ function() {
    "use strict";
    function Snapshot(element) {
        (0, $9j09T._)(this, Snapshot);
        this.element = element;
    }
    (0, $eDeHT._)(Snapshot, [
        {
            key: "activeElement",
            get: function get() {
                return this.element.ownerDocument.activeElement;
            }
        },
        {
            key: "children",
            get: function get() {
                return (0, $enL5v._)(this.element.children);
            }
        },
        {
            key: "hasAnchor",
            value: function hasAnchor(anchor) {
                return this.getElementForAnchor(anchor) != null;
            }
        },
        {
            key: "getElementForAnchor",
            value: function getElementForAnchor(anchor) {
                return anchor ? this.element.querySelector("[id='".concat(anchor, "'], a[name='").concat(anchor, "']")) : null;
            }
        },
        {
            key: "isConnected",
            get: function get() {
                return this.element.isConnected;
            }
        },
        {
            key: "firstAutofocusableElement",
            get: function get() {
                var inertDisabledOrHidden = "[inert], :disabled, [hidden], details:not([open]), dialog:not([open])";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.element.querySelectorAll("[autofocus]")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (element.closest(inertDisabledOrHidden) == null) return element;
                        else continue;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "permanentElements",
            get: function get() {
                return queryPermanentElementsAll(this.element);
            }
        },
        {
            key: "getPermanentElementById",
            value: function getPermanentElementById1(id) {
                return getPermanentElementById(this.element, id);
            }
        },
        {
            key: "getPermanentElementMapForSnapshot",
            value: function getPermanentElementMapForSnapshot(snapshot) {
                var permanentElementMap = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.permanentElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var currentPermanentElement = _step.value;
                        var id = currentPermanentElement.id;
                        var newPermanentElement = snapshot.getPermanentElementById(id);
                        if (newPermanentElement) permanentElementMap[id] = [
                            currentPermanentElement,
                            newPermanentElement
                        ];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return permanentElementMap;
            }
        }
    ]);
    return Snapshot;
}();
function getPermanentElementById(node, id) {
    return node.querySelector("#".concat(id, "[data-turbo-permanent]"));
}
function queryPermanentElementsAll(node) {
    return node.querySelectorAll("[id][data-turbo-permanent]");
}
var FormSubmitObserver = /*#__PURE__*/ function() {
    "use strict";
    function FormSubmitObserver(delegate, eventTarget) {
        var _this = this;
        (0, $9j09T._)(this, FormSubmitObserver);
        this.started = false;
        this.submitCaptured = function() {
            _this.eventTarget.removeEventListener("submit", _this.submitBubbled, false);
            _this.eventTarget.addEventListener("submit", _this.submitBubbled, false);
        };
        this.submitBubbled = function(event) {
            if (!event.defaultPrevented) {
                var form = event.target instanceof HTMLFormElement ? event.target : undefined;
                var submitter = event.submitter || undefined;
                if (form && submissionDoesNotDismissDialog(form, submitter) && submissionDoesNotTargetIFrame(form, submitter) && _this.delegate.willSubmitForm(form, submitter)) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    _this.delegate.formSubmitted(form, submitter);
                }
            }
        };
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    (0, $eDeHT._)(FormSubmitObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.eventTarget.addEventListener("submit", this.submitCaptured, true);
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.eventTarget.removeEventListener("submit", this.submitCaptured, true);
                    this.started = false;
                }
            }
        }
    ]);
    return FormSubmitObserver;
}();
function submissionDoesNotDismissDialog(form, submitter) {
    var method = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || form.getAttribute("method");
    return method != "dialog";
}
function submissionDoesNotTargetIFrame(form, submitter) {
    if ((submitter === null || submitter === void 0 ? void 0 : submitter.hasAttribute("formtarget")) || form.hasAttribute("target")) {
        var target = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formtarget")) || form.target;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = document.getElementsByName(target)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                if (element instanceof HTMLIFrameElement) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    } else return true;
}
var View = /*#__PURE__*/ function() {
    "use strict";
    function View(delegate, element) {
        (0, $9j09T._)(this, View);
        this.resolveRenderPromise = function(_value) {};
        this.resolveInterceptionPromise = function(_value) {};
        this.delegate = delegate;
        this.element = element;
    }
    (0, $eDeHT._)(View, [
        {
            key: "scrollToAnchor",
            value: function scrollToAnchor(anchor) {
                var element = this.snapshot.getElementForAnchor(anchor);
                if (element) {
                    this.scrollToElement(element);
                    this.focusElement(element);
                } else this.scrollToPosition({
                    x: 0,
                    y: 0
                });
            }
        },
        {
            key: "scrollToAnchorFromLocation",
            value: function scrollToAnchorFromLocation(location1) {
                this.scrollToAnchor(getAnchor(location1));
            }
        },
        {
            key: "scrollToElement",
            value: function scrollToElement(element) {
                element.scrollIntoView();
            }
        },
        {
            key: "focusElement",
            value: function focusElement(element) {
                if (element instanceof HTMLElement) {
                    if (element.hasAttribute("tabindex")) element.focus();
                    else {
                        element.setAttribute("tabindex", "-1");
                        element.focus();
                        element.removeAttribute("tabindex");
                    }
                }
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition(param) {
                var x = param.x, y = param.y;
                this.scrollRoot.scrollTo(x, y);
            }
        },
        {
            key: "scrollToTop",
            value: function scrollToTop() {
                this.scrollToPosition({
                    x: 0,
                    y: 0
                });
            }
        },
        {
            key: "scrollRoot",
            get: function get() {
                return window;
            }
        },
        {
            key: "render",
            value: function render(renderer) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var isPreview, shouldRender, snapshot, renderInterception, options, immediateRender;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                isPreview = renderer.isPreview, shouldRender = renderer.shouldRender, snapshot = renderer.newSnapshot;
                                if (!shouldRender) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    6,
                                    7
                                ]);
                                _this.renderPromise = new Promise(function(resolve) {
                                    return _this.resolveRenderPromise = resolve;
                                });
                                _this.renderer = renderer;
                                return [
                                    4,
                                    _this.prepareToRenderSnapshot(renderer)
                                ];
                            case 2:
                                _state.sent();
                                renderInterception = new Promise(function(resolve) {
                                    return _this.resolveInterceptionPromise = resolve;
                                });
                                options = {
                                    resume: _this.resolveInterceptionPromise,
                                    render: _this.renderer.renderElement
                                };
                                immediateRender = _this.delegate.allowsImmediateRender(snapshot, options);
                                if (!!immediateRender) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    renderInterception
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    4,
                                    _this.renderSnapshot(renderer)
                                ];
                            case 5:
                                _state.sent();
                                _this.delegate.viewRenderedSnapshot(snapshot, isPreview);
                                _this.delegate.preloadOnLoadLinksForView(_this.element);
                                _this.finishRenderingSnapshot(renderer);
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                delete _this.renderer;
                                _this.resolveRenderPromise(undefined);
                                delete _this.renderPromise;
                                return [
                                    7
                                ];
                            case 7:
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                _this.invalidate(renderer.reloadReason);
                                _state.label = 9;
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "invalidate",
            value: function invalidate(reason) {
                this.delegate.viewInvalidated(reason);
            }
        },
        {
            key: "prepareToRenderSnapshot",
            value: function prepareToRenderSnapshot(renderer) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.markAsPreview(renderer.isPreview);
                                return [
                                    4,
                                    renderer.prepareToRender()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "markAsPreview",
            value: function markAsPreview(isPreview) {
                if (isPreview) this.element.setAttribute("data-turbo-preview", "");
                else this.element.removeAttribute("data-turbo-preview");
            }
        },
        {
            key: "renderSnapshot",
            value: function renderSnapshot(renderer) {
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    renderer.render()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finishRenderingSnapshot",
            value: function finishRenderingSnapshot(renderer) {
                renderer.finishRendering();
            }
        }
    ]);
    return View;
}();
var FrameView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $i0LXg._)(FrameView, View);
    var _super = (0, $a1vXf._)(FrameView);
    function FrameView() {
        (0, $9j09T._)(this, FrameView);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(FrameView, [
        {
            key: "missing",
            value: function missing() {
                this.element.innerHTML = '<strong class="turbo-frame-error">Content missing</strong>';
            }
        },
        {
            key: "snapshot",
            get: function get() {
                return new Snapshot(this.element);
            }
        }
    ]);
    return FrameView;
}(View);
var LinkInterceptor = /*#__PURE__*/ function() {
    "use strict";
    function LinkInterceptor(delegate, element) {
        var _this = this;
        (0, $9j09T._)(this, LinkInterceptor);
        this.clickBubbled = function(event) {
            if (_this.respondsToEventTarget(event.target)) _this.clickEvent = event;
            else delete _this.clickEvent;
        };
        this.linkClicked = function(event) {
            if (_this.clickEvent && _this.respondsToEventTarget(event.target) && event.target instanceof Element) {
                if (_this.delegate.shouldInterceptLinkClick(event.target, event.detail.url, event.detail.originalEvent)) {
                    _this.clickEvent.preventDefault();
                    event.preventDefault();
                    _this.delegate.linkClickIntercepted(event.target, event.detail.url, event.detail.originalEvent);
                }
            }
            delete _this.clickEvent;
        };
        this.willVisit = function(_event) {
            delete _this.clickEvent;
        };
        this.delegate = delegate;
        this.element = element;
    }
    (0, $eDeHT._)(LinkInterceptor, [
        {
            key: "start",
            value: function start() {
                this.element.addEventListener("click", this.clickBubbled);
                document.addEventListener("turbo:click", this.linkClicked);
                document.addEventListener("turbo:before-visit", this.willVisit);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.element.removeEventListener("click", this.clickBubbled);
                document.removeEventListener("turbo:click", this.linkClicked);
                document.removeEventListener("turbo:before-visit", this.willVisit);
            }
        },
        {
            key: "respondsToEventTarget",
            value: function respondsToEventTarget(target) {
                var element = target instanceof Element ? target : target instanceof Node ? target.parentElement : null;
                return element && element.closest("turbo-frame, html") == this.element;
            }
        }
    ]);
    return LinkInterceptor;
}();
var LinkClickObserver = /*#__PURE__*/ function() {
    "use strict";
    function LinkClickObserver(delegate, eventTarget) {
        var _this = this;
        (0, $9j09T._)(this, LinkClickObserver);
        this.started = false;
        this.clickCaptured = function() {
            _this.eventTarget.removeEventListener("click", _this.clickBubbled, false);
            _this.eventTarget.addEventListener("click", _this.clickBubbled, false);
        };
        this.clickBubbled = function(event) {
            if (event instanceof MouseEvent && _this.clickEventIsSignificant(event)) {
                var target = event.composedPath && event.composedPath()[0] || event.target;
                var link = _this.findLinkFromClickTarget(target);
                if (link && doesNotTargetIFrame(link)) {
                    var location1 = _this.getLocationForLink(link);
                    if (_this.delegate.willFollowLinkToLocation(link, location1, event)) {
                        event.preventDefault();
                        _this.delegate.followedLinkToLocation(link, location1);
                    }
                }
            }
        };
        this.delegate = delegate;
        this.eventTarget = eventTarget;
    }
    (0, $eDeHT._)(LinkClickObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.eventTarget.addEventListener("click", this.clickCaptured, true);
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.eventTarget.removeEventListener("click", this.clickCaptured, true);
                    this.started = false;
                }
            }
        },
        {
            key: "clickEventIsSignificant",
            value: function clickEventIsSignificant(event) {
                return !(event.target && event.target.isContentEditable || event.defaultPrevented || event.which > 1 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
            }
        },
        {
            key: "findLinkFromClickTarget",
            value: function findLinkFromClickTarget(target) {
                return findClosestRecursively(target, "a[href]:not([target^=_]):not([download])");
            }
        },
        {
            key: "getLocationForLink",
            value: function getLocationForLink(link) {
                return expandURL(link.getAttribute("href") || "");
            }
        }
    ]);
    return LinkClickObserver;
}();
function doesNotTargetIFrame(anchor) {
    if (anchor.hasAttribute("target")) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = document.getElementsByName(anchor.target)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                if (element instanceof HTMLIFrameElement) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    } else return true;
}
var FormLinkClickObserver = /*#__PURE__*/ function() {
    "use strict";
    function FormLinkClickObserver(delegate, element) {
        (0, $9j09T._)(this, FormLinkClickObserver);
        this.delegate = delegate;
        this.linkInterceptor = new LinkClickObserver(this, element);
    }
    (0, $eDeHT._)(FormLinkClickObserver, [
        {
            key: "start",
            value: function start() {
                this.linkInterceptor.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.linkInterceptor.stop();
            }
        },
        {
            key: "willFollowLinkToLocation",
            value: function willFollowLinkToLocation(link, location1, originalEvent) {
                return this.delegate.willSubmitFormLinkToLocation(link, location1, originalEvent) && link.hasAttribute("data-turbo-method");
            }
        },
        {
            key: "followedLinkToLocation",
            value: function followedLinkToLocation(link, location1) {
                var form = document.createElement("form");
                var type = "hidden";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = location1.searchParams[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $fyOZQ._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                        form.append(Object.assign(document.createElement("input"), {
                            type: type,
                            name: name,
                            value: value
                        }));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var action = Object.assign(location1, {
                    search: ""
                });
                form.setAttribute("data-turbo", "true");
                form.setAttribute("action", action.href);
                form.setAttribute("hidden", "");
                var method = link.getAttribute("data-turbo-method");
                if (method) form.setAttribute("method", method);
                var turboFrame = link.getAttribute("data-turbo-frame");
                if (turboFrame) form.setAttribute("data-turbo-frame", turboFrame);
                var turboAction = getVisitAction(link);
                if (turboAction) form.setAttribute("data-turbo-action", turboAction);
                var turboConfirm = link.getAttribute("data-turbo-confirm");
                if (turboConfirm) form.setAttribute("data-turbo-confirm", turboConfirm);
                var turboStream = link.hasAttribute("data-turbo-stream");
                if (turboStream) form.setAttribute("data-turbo-stream", "");
                this.delegate.submittedFormLinkToLocation(link, location1, form);
                document.body.appendChild(form);
                form.addEventListener("turbo:submit-end", function() {
                    return form.remove();
                }, {
                    once: true
                });
                requestAnimationFrame(function() {
                    return form.requestSubmit();
                });
            }
        }
    ]);
    return FormLinkClickObserver;
}();
var Bardo = /*#__PURE__*/ function() {
    "use strict";
    function Bardo(delegate, permanentElementMap) {
        (0, $9j09T._)(this, Bardo);
        this.delegate = delegate;
        this.permanentElementMap = permanentElementMap;
    }
    (0, $eDeHT._)(Bardo, [
        {
            key: "enter",
            value: function enter() {
                for(var id in this.permanentElementMap){
                    var _this_permanentElementMap_id = (0, $fyOZQ._)(this.permanentElementMap[id], 2), currentPermanentElement = _this_permanentElementMap_id[0], newPermanentElement = _this_permanentElementMap_id[1];
                    this.delegate.enteringBardo(currentPermanentElement, newPermanentElement);
                    this.replaceNewPermanentElementWithPlaceholder(newPermanentElement);
                }
            }
        },
        {
            key: "leave",
            value: function leave() {
                for(var id in this.permanentElementMap){
                    var _this_permanentElementMap_id = (0, $fyOZQ._)(this.permanentElementMap[id], 1), currentPermanentElement = _this_permanentElementMap_id[0];
                    this.replaceCurrentPermanentElementWithClone(currentPermanentElement);
                    this.replacePlaceholderWithPermanentElement(currentPermanentElement);
                    this.delegate.leavingBardo(currentPermanentElement);
                }
            }
        },
        {
            key: "replaceNewPermanentElementWithPlaceholder",
            value: function replaceNewPermanentElementWithPlaceholder(permanentElement) {
                var placeholder = createPlaceholderForPermanentElement(permanentElement);
                permanentElement.replaceWith(placeholder);
            }
        },
        {
            key: "replaceCurrentPermanentElementWithClone",
            value: function replaceCurrentPermanentElementWithClone(permanentElement) {
                var clone = permanentElement.cloneNode(true);
                permanentElement.replaceWith(clone);
            }
        },
        {
            key: "replacePlaceholderWithPermanentElement",
            value: function replacePlaceholderWithPermanentElement(permanentElement) {
                var placeholder = this.getPlaceholderById(permanentElement.id);
                placeholder === null || placeholder === void 0 || placeholder.replaceWith(permanentElement);
            }
        },
        {
            key: "getPlaceholderById",
            value: function getPlaceholderById(id) {
                return this.placeholders.find(function(element) {
                    return element.content == id;
                });
            }
        },
        {
            key: "placeholders",
            get: function get() {
                return (0, $enL5v._)(document.querySelectorAll("meta[name=turbo-permanent-placeholder][content]"));
            }
        }
    ], [
        {
            key: "preservingPermanentElements",
            value: function preservingPermanentElements(delegate, permanentElementMap, callback) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var bardo;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                bardo = new _this(delegate, permanentElementMap);
                                bardo.enter();
                                return [
                                    4,
                                    callback()
                                ];
                            case 1:
                                _state.sent();
                                bardo.leave();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Bardo;
}();
function createPlaceholderForPermanentElement(permanentElement) {
    var element = document.createElement("meta");
    element.setAttribute("name", "turbo-permanent-placeholder");
    element.setAttribute("content", permanentElement.id);
    return element;
}
var Renderer = /*#__PURE__*/ function() {
    "use strict";
    function Renderer(currentSnapshot, newSnapshot, renderElement, isPreview) {
        var willRender = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
        var _this = this;
        (0, $9j09T._)(this, Renderer);
        this.activeElement = null;
        this.currentSnapshot = currentSnapshot;
        this.newSnapshot = newSnapshot;
        this.isPreview = isPreview;
        this.willRender = willRender;
        this.renderElement = renderElement;
        this.promise = new Promise(function(resolve, reject) {
            return _this.resolvingFunctions = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    (0, $eDeHT._)(Renderer, [
        {
            key: "shouldRender",
            get: function get() {
                return true;
            }
        },
        {
            key: "reloadReason",
            get: function get() {
                return;
            }
        },
        {
            key: "prepareToRender",
            value: function prepareToRender() {
                return;
            }
        },
        {
            key: "finishRendering",
            value: function finishRendering() {
                if (this.resolvingFunctions) {
                    this.resolvingFunctions.resolve();
                    delete this.resolvingFunctions;
                }
            }
        },
        {
            key: "preservingPermanentElements",
            value: function preservingPermanentElements(callback) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Bardo.preservingPermanentElements(_this, _this.permanentElementMap, callback)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "focusFirstAutofocusableElement",
            value: function focusFirstAutofocusableElement() {
                var element = this.connectedSnapshot.firstAutofocusableElement;
                if (elementIsFocusable(element)) element.focus();
            }
        },
        {
            key: "enteringBardo",
            value: function enteringBardo(currentPermanentElement) {
                if (this.activeElement) return;
                if (currentPermanentElement.contains(this.currentSnapshot.activeElement)) this.activeElement = this.currentSnapshot.activeElement;
            }
        },
        {
            key: "leavingBardo",
            value: function leavingBardo(currentPermanentElement) {
                if (currentPermanentElement.contains(this.activeElement) && this.activeElement instanceof HTMLElement) {
                    this.activeElement.focus();
                    this.activeElement = null;
                }
            }
        },
        {
            key: "connectedSnapshot",
            get: function get() {
                return this.newSnapshot.isConnected ? this.newSnapshot : this.currentSnapshot;
            }
        },
        {
            key: "currentElement",
            get: function get() {
                return this.currentSnapshot.element;
            }
        },
        {
            key: "newElement",
            get: function get() {
                return this.newSnapshot.element;
            }
        },
        {
            key: "permanentElementMap",
            get: function get() {
                return this.currentSnapshot.getPermanentElementMapForSnapshot(this.newSnapshot);
            }
        }
    ]);
    return Renderer;
}();
function elementIsFocusable(element) {
    return element && typeof element.focus == "function";
}
var FrameRenderer = /*#__PURE__*/ function(Renderer) {
    "use strict";
    (0, $i0LXg._)(FrameRenderer, Renderer);
    var _super = (0, $a1vXf._)(FrameRenderer);
    function FrameRenderer(delegate, currentSnapshot, newSnapshot, renderElement, isPreview) {
        var willRender = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true;
        (0, $9j09T._)(this, FrameRenderer);
        var _this;
        _this = _super.call(this, currentSnapshot, newSnapshot, renderElement, isPreview, willRender);
        _this.delegate = delegate;
        return _this;
    }
    (0, $eDeHT._)(FrameRenderer, [
        {
            key: "shouldRender",
            get: function get() {
                return true;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    nextAnimationFrame()
                                ];
                            case 1:
                                _state.sent();
                                _this.preservingPermanentElements(function() {
                                    _this.loadFrameElement();
                                });
                                _this.scrollFrameIntoView();
                                return [
                                    4,
                                    nextAnimationFrame()
                                ];
                            case 2:
                                _state.sent();
                                _this.focusFirstAutofocusableElement();
                                return [
                                    4,
                                    nextAnimationFrame()
                                ];
                            case 3:
                                _state.sent();
                                _this.activateScriptElements();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadFrameElement",
            value: function loadFrameElement() {
                this.delegate.willRenderFrame(this.currentElement, this.newElement);
                this.renderElement(this.currentElement, this.newElement);
            }
        },
        {
            key: "scrollFrameIntoView",
            value: function scrollFrameIntoView() {
                if (this.currentElement.autoscroll || this.newElement.autoscroll) {
                    var element = this.currentElement.firstElementChild;
                    var block = readScrollLogicalPosition(this.currentElement.getAttribute("data-autoscroll-block"), "end");
                    var behavior = readScrollBehavior(this.currentElement.getAttribute("data-autoscroll-behavior"), "auto");
                    if (element) {
                        element.scrollIntoView({
                            block: block,
                            behavior: behavior
                        });
                        return true;
                    }
                }
                return false;
            }
        },
        {
            key: "activateScriptElements",
            value: function activateScriptElements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.newScriptElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var inertScriptElement = _step.value;
                        var activatedScriptElement = activateScriptElement(inertScriptElement);
                        inertScriptElement.replaceWith(activatedScriptElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "newScriptElements",
            get: function get() {
                return this.currentElement.querySelectorAll("script");
            }
        }
    ], [
        {
            key: "renderElement",
            value: function renderElement(currentElement, newElement) {
                var _a;
                var destinationRange = document.createRange();
                destinationRange.selectNodeContents(currentElement);
                destinationRange.deleteContents();
                var frameElement = newElement;
                var sourceRange = (_a = frameElement.ownerDocument) === null || _a === void 0 ? void 0 : _a.createRange();
                if (sourceRange) {
                    sourceRange.selectNodeContents(frameElement);
                    currentElement.appendChild(sourceRange.extractContents());
                }
            }
        }
    ]);
    return FrameRenderer;
}(Renderer);
function readScrollLogicalPosition(value, defaultValue) {
    if (value == "end" || value == "start" || value == "center" || value == "nearest") return value;
    else return defaultValue;
}
function readScrollBehavior(value, defaultValue) {
    if (value == "auto" || value == "smooth") return value;
    else return defaultValue;
}
var ProgressBar = /*#__PURE__*/ function() {
    "use strict";
    function ProgressBar() {
        var _this = this;
        (0, $9j09T._)(this, ProgressBar);
        this.hiding = false;
        this.value = 0;
        this.visible = false;
        this.trickle = function() {
            _this.setValue(_this.value + Math.random() / 100);
        };
        this.stylesheetElement = this.createStylesheetElement();
        this.progressElement = this.createProgressElement();
        this.installStylesheetElement();
        this.setValue(0);
    }
    (0, $eDeHT._)(ProgressBar, [
        {
            key: "show",
            value: function show() {
                if (!this.visible) {
                    this.visible = true;
                    this.installProgressElement();
                    this.startTrickling();
                }
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this.visible && !this.hiding) {
                    this.hiding = true;
                    this.fadeProgressElement(function() {
                        _this.uninstallProgressElement();
                        _this.stopTrickling();
                        _this.visible = false;
                        _this.hiding = false;
                    });
                }
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                this.value = value;
                this.refresh();
            }
        },
        {
            key: "installStylesheetElement",
            value: function installStylesheetElement() {
                document.head.insertBefore(this.stylesheetElement, document.head.firstChild);
            }
        },
        {
            key: "installProgressElement",
            value: function installProgressElement() {
                this.progressElement.style.width = "0";
                this.progressElement.style.opacity = "1";
                document.documentElement.insertBefore(this.progressElement, document.body);
                this.refresh();
            }
        },
        {
            key: "fadeProgressElement",
            value: function fadeProgressElement(callback) {
                this.progressElement.style.opacity = "0";
                setTimeout(callback, ProgressBar.animationDuration * 1.5);
            }
        },
        {
            key: "uninstallProgressElement",
            value: function uninstallProgressElement() {
                if (this.progressElement.parentNode) document.documentElement.removeChild(this.progressElement);
            }
        },
        {
            key: "startTrickling",
            value: function startTrickling() {
                if (!this.trickleInterval) this.trickleInterval = window.setInterval(this.trickle, ProgressBar.animationDuration);
            }
        },
        {
            key: "stopTrickling",
            value: function stopTrickling() {
                window.clearInterval(this.trickleInterval);
                delete this.trickleInterval;
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this = this;
                requestAnimationFrame(function() {
                    _this.progressElement.style.width = "".concat(10 + _this.value * 90, "%");
                });
            }
        },
        {
            key: "createStylesheetElement",
            value: function createStylesheetElement() {
                var element = document.createElement("style");
                element.type = "text/css";
                element.textContent = ProgressBar.defaultCSS;
                if (this.cspNonce) element.nonce = this.cspNonce;
                return element;
            }
        },
        {
            key: "createProgressElement",
            value: function createProgressElement() {
                var element = document.createElement("div");
                element.className = "turbo-progress-bar";
                return element;
            }
        },
        {
            key: "cspNonce",
            get: function get() {
                return getMetaContent("csp-nonce");
            }
        }
    ], [
        {
            key: "defaultCSS",
            get: function get() {
                return unindent(_templateObject(), ProgressBar.animationDuration, ProgressBar.animationDuration / 2, ProgressBar.animationDuration / 2);
            }
        }
    ]);
    return ProgressBar;
}();
ProgressBar.animationDuration = 300;
var HeadSnapshot = /*#__PURE__*/ function(Snapshot) {
    "use strict";
    (0, $i0LXg._)(HeadSnapshot, Snapshot);
    var _super = (0, $a1vXf._)(HeadSnapshot);
    function HeadSnapshot() {
        (0, $9j09T._)(this, HeadSnapshot);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.detailsByOuterHTML = _this.children.filter(function(element) {
            return !elementIsNoscript(element);
        }).map(function(element) {
            return elementWithoutNonce(element);
        }).reduce(function(result, element) {
            var outerHTML = element.outerHTML;
            var details = outerHTML in result ? result[outerHTML] : {
                type: elementType(element),
                tracked: elementIsTracked(element),
                elements: []
            };
            return Object.assign(Object.assign({}, result), (0, $Npnks._)({}, outerHTML, Object.assign(Object.assign({}, details), {
                elements: (0, $enL5v._)(details.elements).concat([
                    element
                ])
            })));
        }, {});
        return _this;
    }
    (0, $eDeHT._)(HeadSnapshot, [
        {
            key: "trackedElementSignature",
            get: function get() {
                var _this = this;
                return Object.keys(this.detailsByOuterHTML).filter(function(outerHTML) {
                    return _this.detailsByOuterHTML[outerHTML].tracked;
                }).join("");
            }
        },
        {
            key: "getScriptElementsNotInSnapshot",
            value: function getScriptElementsNotInSnapshot(snapshot) {
                return this.getElementsMatchingTypeNotInSnapshot("script", snapshot);
            }
        },
        {
            key: "getStylesheetElementsNotInSnapshot",
            value: function getStylesheetElementsNotInSnapshot(snapshot) {
                return this.getElementsMatchingTypeNotInSnapshot("stylesheet", snapshot);
            }
        },
        {
            key: "getElementsMatchingTypeNotInSnapshot",
            value: function getElementsMatchingTypeNotInSnapshot(matchedType, snapshot) {
                var _this = this;
                return Object.keys(this.detailsByOuterHTML).filter(function(outerHTML) {
                    return !(outerHTML in snapshot.detailsByOuterHTML);
                }).map(function(outerHTML) {
                    return _this.detailsByOuterHTML[outerHTML];
                }).filter(function(param) {
                    var type = param.type;
                    return type == matchedType;
                }).map(function(param) {
                    var _param_elements = (0, $fyOZQ._)(param.elements, 1), element = _param_elements[0];
                    return element;
                });
            }
        },
        {
            key: "provisionalElements",
            get: function get() {
                var _this = this;
                return Object.keys(this.detailsByOuterHTML).reduce(function(result, outerHTML) {
                    var _this_detailsByOuterHTML_outerHTML = _this.detailsByOuterHTML[outerHTML], type = _this_detailsByOuterHTML_outerHTML.type, tracked = _this_detailsByOuterHTML_outerHTML.tracked, elements = _this_detailsByOuterHTML_outerHTML.elements;
                    if (type == null && !tracked) return (0, $enL5v._)(result).concat((0, $enL5v._)(elements));
                    else if (elements.length > 1) return (0, $enL5v._)(result).concat((0, $enL5v._)(elements.slice(1)));
                    else return result;
                }, []);
            }
        },
        {
            key: "getMetaValue",
            value: function getMetaValue(name) {
                var element = this.findMetaElementByName(name);
                return element ? element.getAttribute("content") : null;
            }
        },
        {
            key: "findMetaElementByName",
            value: function findMetaElementByName(name) {
                var _this = this;
                return Object.keys(this.detailsByOuterHTML).reduce(function(result, outerHTML) {
                    var _this_detailsByOuterHTML_outerHTML = _this.detailsByOuterHTML[outerHTML], _this_detailsByOuterHTML_outerHTML_elements = (0, $fyOZQ._)(_this_detailsByOuterHTML_outerHTML.elements, 1), element = _this_detailsByOuterHTML_outerHTML_elements[0];
                    return elementIsMetaElementWithName(element, name) ? element : result;
                }, undefined);
            }
        }
    ]);
    return HeadSnapshot;
}(Snapshot);
function elementType(element) {
    if (elementIsScript(element)) return "script";
    else if (elementIsStylesheet(element)) return "stylesheet";
}
function elementIsTracked(element) {
    return element.getAttribute("data-turbo-track") == "reload";
}
function elementIsScript(element) {
    var tagName = element.localName;
    return tagName == "script";
}
function elementIsNoscript(element) {
    var tagName = element.localName;
    return tagName == "noscript";
}
function elementIsStylesheet(element) {
    var tagName = element.localName;
    return tagName == "style" || tagName == "link" && element.getAttribute("rel") == "stylesheet";
}
function elementIsMetaElementWithName(element, name) {
    var tagName = element.localName;
    return tagName == "meta" && element.getAttribute("name") == name;
}
function elementWithoutNonce(element) {
    if (element.hasAttribute("nonce")) element.setAttribute("nonce", "");
    return element;
}
var PageSnapshot = /*#__PURE__*/ function(Snapshot) {
    "use strict";
    (0, $i0LXg._)(PageSnapshot, Snapshot);
    var _super = (0, $a1vXf._)(PageSnapshot);
    function PageSnapshot(element, headSnapshot) {
        (0, $9j09T._)(this, PageSnapshot);
        var _this;
        _this = _super.call(this, element);
        _this.headSnapshot = headSnapshot;
        return _this;
    }
    (0, $eDeHT._)(PageSnapshot, [
        {
            key: "clone",
            value: function clone() {
                var clonedElement = this.element.cloneNode(true);
                var selectElements = this.element.querySelectorAll("select");
                var clonedSelectElements = clonedElement.querySelectorAll("select");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectElements.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $fyOZQ._)(_step.value, 2), index = _step_value[0], source = _step_value[1];
                        var clone = clonedSelectElements[index];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = clone.selectedOptions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var option = _step1.value;
                                option.selected = false;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = source.selectedOptions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var option1 = _step2.value;
                                clone.options[option1.index].selected = true;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = clonedElement.querySelectorAll('input[type="password"]')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var clonedPasswordInput = _step3.value;
                        clonedPasswordInput.value = "";
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
                return new PageSnapshot(clonedElement, this.headSnapshot);
            }
        },
        {
            key: "headElement",
            get: function get() {
                return this.headSnapshot.element;
            }
        },
        {
            key: "rootLocation",
            get: function get() {
                var _a;
                var root = (_a = this.getSetting("root")) !== null && _a !== void 0 ? _a : "/";
                return expandURL(root);
            }
        },
        {
            key: "cacheControlValue",
            get: function get() {
                return this.getSetting("cache-control");
            }
        },
        {
            key: "isPreviewable",
            get: function get() {
                return this.cacheControlValue != "no-preview";
            }
        },
        {
            key: "isCacheable",
            get: function get() {
                return this.cacheControlValue != "no-cache";
            }
        },
        {
            key: "isVisitable",
            get: function get() {
                return this.getSetting("visit-control") != "reload";
            }
        },
        {
            key: "getSetting",
            value: function getSetting(name) {
                return this.headSnapshot.getMetaValue("turbo-".concat(name));
            }
        }
    ], [
        {
            key: "fromHTMLString",
            value: function fromHTMLString() {
                var html = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                return this.fromDocument(parseHTMLDocument(html));
            }
        },
        {
            key: "fromElement",
            value: function fromElement(element) {
                return this.fromDocument(element.ownerDocument);
            }
        },
        {
            key: "fromDocument",
            value: function fromDocument(param) {
                var head = param.head, body = param.body;
                return new this(body, new HeadSnapshot(head));
            }
        }
    ]);
    return PageSnapshot;
}(Snapshot);
var TimingMetric;
(function(TimingMetric) {
    TimingMetric["visitStart"] = "visitStart";
    TimingMetric["requestStart"] = "requestStart";
    TimingMetric["requestEnd"] = "requestEnd";
    TimingMetric["visitEnd"] = "visitEnd";
})(TimingMetric || (TimingMetric = {}));
var VisitState;
(function(VisitState) {
    VisitState["initialized"] = "initialized";
    VisitState["started"] = "started";
    VisitState["canceled"] = "canceled";
    VisitState["failed"] = "failed";
    VisitState["completed"] = "completed";
})(VisitState || (VisitState = {}));
var defaultOptions = {
    action: "advance",
    historyChanged: false,
    visitCachedSnapshot: function() {},
    willRender: true,
    updateHistory: true,
    shouldCacheSnapshot: true,
    acceptsStreamResponse: false
};
var SystemStatusCode;
(function(SystemStatusCode) {
    SystemStatusCode[SystemStatusCode["networkFailure"] = 0] = "networkFailure";
    SystemStatusCode[SystemStatusCode["timeoutFailure"] = -1] = "timeoutFailure";
    SystemStatusCode[SystemStatusCode["contentTypeMismatch"] = -2] = "contentTypeMismatch";
})(SystemStatusCode || (SystemStatusCode = {}));
var Visit = /*#__PURE__*/ function() {
    "use strict";
    function Visit(delegate, location1, restorationIdentifier) {
        var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        (0, $9j09T._)(this, Visit);
        this.identifier = uuid();
        this.timingMetrics = {};
        this.followedRedirect = false;
        this.historyChanged = false;
        this.scrolled = false;
        this.shouldCacheSnapshot = true;
        this.acceptsStreamResponse = false;
        this.snapshotCached = false;
        this.state = VisitState.initialized;
        this.delegate = delegate;
        this.location = location1;
        this.restorationIdentifier = restorationIdentifier || uuid();
        var _Object_assign = Object.assign(Object.assign({}, defaultOptions), options), action = _Object_assign.action, historyChanged = _Object_assign.historyChanged, referrer = _Object_assign.referrer, snapshot = _Object_assign.snapshot, snapshotHTML = _Object_assign.snapshotHTML, response = _Object_assign.response, visitCachedSnapshot = _Object_assign.visitCachedSnapshot, willRender = _Object_assign.willRender, updateHistory = _Object_assign.updateHistory, shouldCacheSnapshot = _Object_assign.shouldCacheSnapshot, acceptsStreamResponse = _Object_assign.acceptsStreamResponse;
        this.action = action;
        this.historyChanged = historyChanged;
        this.referrer = referrer;
        this.snapshot = snapshot;
        this.snapshotHTML = snapshotHTML;
        this.response = response;
        this.isSamePage = this.delegate.locationWithActionIsSamePage(this.location, this.action);
        this.visitCachedSnapshot = visitCachedSnapshot;
        this.willRender = willRender;
        this.updateHistory = updateHistory;
        this.scrolled = !willRender;
        this.shouldCacheSnapshot = shouldCacheSnapshot;
        this.acceptsStreamResponse = acceptsStreamResponse;
    }
    (0, $eDeHT._)(Visit, [
        {
            key: "adapter",
            get: function get() {
                return this.delegate.adapter;
            }
        },
        {
            key: "view",
            get: function get() {
                return this.delegate.view;
            }
        },
        {
            key: "history",
            get: function get() {
                return this.delegate.history;
            }
        },
        {
            key: "restorationData",
            get: function get() {
                return this.history.getRestorationDataForIdentifier(this.restorationIdentifier);
            }
        },
        {
            key: "silent",
            get: function get() {
                return this.isSamePage;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.state == VisitState.initialized) {
                    this.recordTimingMetric(TimingMetric.visitStart);
                    this.state = VisitState.started;
                    this.adapter.visitStarted(this);
                    this.delegate.visitStarted(this);
                }
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state == VisitState.started) {
                    if (this.request) this.request.cancel();
                    this.cancelRender();
                    this.state = VisitState.canceled;
                }
            }
        },
        {
            key: "complete",
            value: function complete() {
                if (this.state == VisitState.started) {
                    this.recordTimingMetric(TimingMetric.visitEnd);
                    this.state = VisitState.completed;
                    this.followRedirect();
                    if (!this.followedRedirect) {
                        this.adapter.visitCompleted(this);
                        this.delegate.visitCompleted(this);
                    }
                }
            }
        },
        {
            key: "fail",
            value: function fail() {
                if (this.state == VisitState.started) {
                    this.state = VisitState.failed;
                    this.adapter.visitFailed(this);
                }
            }
        },
        {
            key: "changeHistory",
            value: function changeHistory() {
                var _a;
                if (!this.historyChanged && this.updateHistory) {
                    var actionForHistory = this.location.href === ((_a = this.referrer) === null || _a === void 0 ? void 0 : _a.href) ? "replace" : this.action;
                    var method = getHistoryMethodForAction(actionForHistory);
                    this.history.update(method, this.location, this.restorationIdentifier);
                    this.historyChanged = true;
                }
            }
        },
        {
            key: "issueRequest",
            value: function issueRequest() {
                if (this.hasPreloadedResponse()) this.simulateRequest();
                else if (this.shouldIssueRequest() && !this.request) {
                    this.request = new FetchRequest(this, FetchMethod.get, this.location);
                    this.request.perform();
                }
            }
        },
        {
            key: "simulateRequest",
            value: function simulateRequest() {
                if (this.response) {
                    this.startRequest();
                    this.recordResponse();
                    this.finishRequest();
                }
            }
        },
        {
            key: "startRequest",
            value: function startRequest() {
                this.recordTimingMetric(TimingMetric.requestStart);
                this.adapter.visitRequestStarted(this);
            }
        },
        {
            key: "recordResponse",
            value: function recordResponse() {
                var response = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.response;
                this.response = response;
                if (response) {
                    var statusCode = response.statusCode;
                    if (isSuccessful(statusCode)) this.adapter.visitRequestCompleted(this);
                    else this.adapter.visitRequestFailedWithStatusCode(this, statusCode);
                }
            }
        },
        {
            key: "finishRequest",
            value: function finishRequest() {
                this.recordTimingMetric(TimingMetric.requestEnd);
                this.adapter.visitRequestFinished(this);
            }
        },
        {
            key: "loadResponse",
            value: function loadResponse() {
                if (this.response) {
                    var _this_response = this.response, statusCode = _this_response.statusCode, responseHTML = _this_response.responseHTML;
                    var _this = this;
                    this.render(/*#__PURE__*/ (0, $jpnpo._)(function() {
                        return (0, $itJXR.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (_this.shouldCacheSnapshot) _this.cacheSnapshot();
                                    if (!_this.view.renderPromise) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        _this.view.renderPromise
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    if (!(isSuccessful(statusCode) && responseHTML != null)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        _this.view.renderPage(PageSnapshot.fromHTMLString(responseHTML), false, _this.willRender, _this)
                                    ];
                                case 3:
                                    _state.sent();
                                    _this.performScroll();
                                    _this.adapter.visitRendered(_this);
                                    _this.complete();
                                    return [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        _this.view.renderError(PageSnapshot.fromHTMLString(responseHTML), _this)
                                    ];
                                case 5:
                                    _state.sent();
                                    _this.adapter.visitRendered(_this);
                                    _this.fail();
                                    _state.label = 6;
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                }
            }
        },
        {
            key: "getCachedSnapshot",
            value: function getCachedSnapshot() {
                var snapshot = this.view.getCachedSnapshotForLocation(this.location) || this.getPreloadedSnapshot();
                if (snapshot && (!getAnchor(this.location) || snapshot.hasAnchor(getAnchor(this.location)))) {
                    if (this.action == "restore" || snapshot.isPreviewable) return snapshot;
                }
            }
        },
        {
            key: "getPreloadedSnapshot",
            value: function getPreloadedSnapshot() {
                if (this.snapshotHTML) return PageSnapshot.fromHTMLString(this.snapshotHTML);
            }
        },
        {
            key: "hasCachedSnapshot",
            value: function hasCachedSnapshot() {
                return this.getCachedSnapshot() != null;
            }
        },
        {
            key: "loadCachedSnapshot",
            value: function loadCachedSnapshot() {
                var snapshot = this.getCachedSnapshot();
                if (snapshot) {
                    var isPreview = this.shouldIssueRequest();
                    var _this = this;
                    this.render(/*#__PURE__*/ (0, $jpnpo._)(function() {
                        return (0, $itJXR.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.cacheSnapshot();
                                    if (!_this.isSamePage) return [
                                        3,
                                        1
                                    ];
                                    _this.adapter.visitRendered(_this);
                                    return [
                                        3,
                                        5
                                    ];
                                case 1:
                                    if (!_this.view.renderPromise) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        _this.view.renderPromise
                                    ];
                                case 2:
                                    _state.sent();
                                    _state.label = 3;
                                case 3:
                                    return [
                                        4,
                                        _this.view.renderPage(snapshot, isPreview, _this.willRender, _this)
                                    ];
                                case 4:
                                    _state.sent();
                                    _this.performScroll();
                                    _this.adapter.visitRendered(_this);
                                    if (!isPreview) _this.complete();
                                    _state.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                }
            }
        },
        {
            key: "followRedirect",
            value: function followRedirect() {
                var _a;
                if (this.redirectedToLocation && !this.followedRedirect && ((_a = this.response) === null || _a === void 0 ? void 0 : _a.redirected)) {
                    this.adapter.visitProposedToLocation(this.redirectedToLocation, {
                        action: "replace",
                        response: this.response,
                        shouldCacheSnapshot: false,
                        willRender: false
                    });
                    this.followedRedirect = true;
                }
            }
        },
        {
            key: "goToSamePageAnchor",
            value: function goToSamePageAnchor() {
                var _this = this;
                if (this.isSamePage) this.render(/*#__PURE__*/ (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        _this.cacheSnapshot();
                        _this.performScroll();
                        _this.changeHistory();
                        _this.adapter.visitRendered(_this);
                        return [
                            2
                        ];
                    });
                }));
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(request) {
                if (this.acceptsStreamResponse) request.acceptResponseType(StreamMessage.contentType);
            }
        },
        {
            key: "requestStarted",
            value: function requestStarted() {
                this.startRequest();
            }
        },
        {
            key: "requestPreventedHandlingResponse",
            value: function requestPreventedHandlingResponse(_request, _response) {}
        },
        {
            key: "requestSucceededWithResponse",
            value: function requestSucceededWithResponse(request, response) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var responseHTML, redirected, statusCode;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    response.responseHTML
                                ];
                            case 1:
                                responseHTML = _state.sent();
                                redirected = response.redirected, statusCode = response.statusCode;
                                if (responseHTML == undefined) _this.recordResponse({
                                    statusCode: SystemStatusCode.contentTypeMismatch,
                                    redirected: redirected
                                });
                                else {
                                    _this.redirectedToLocation = response.redirected ? response.location : undefined;
                                    _this.recordResponse({
                                        statusCode: statusCode,
                                        responseHTML: responseHTML,
                                        redirected: redirected
                                    });
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestFailedWithResponse",
            value: function requestFailedWithResponse(request, response) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var responseHTML, redirected, statusCode;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    response.responseHTML
                                ];
                            case 1:
                                responseHTML = _state.sent();
                                redirected = response.redirected, statusCode = response.statusCode;
                                if (responseHTML == undefined) _this.recordResponse({
                                    statusCode: SystemStatusCode.contentTypeMismatch,
                                    redirected: redirected
                                });
                                else _this.recordResponse({
                                    statusCode: statusCode,
                                    responseHTML: responseHTML,
                                    redirected: redirected
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestErrored",
            value: function requestErrored(_request, _error) {
                this.recordResponse({
                    statusCode: SystemStatusCode.networkFailure,
                    redirected: false
                });
            }
        },
        {
            key: "requestFinished",
            value: function requestFinished() {
                this.finishRequest();
            }
        },
        {
            key: "performScroll",
            value: function performScroll() {
                if (!this.scrolled && !this.view.forceReloaded) {
                    if (this.action == "restore") this.scrollToRestoredPosition() || this.scrollToAnchor() || this.view.scrollToTop();
                    else this.scrollToAnchor() || this.view.scrollToTop();
                    if (this.isSamePage) this.delegate.visitScrolledToSamePageLocation(this.view.lastRenderedLocation, this.location);
                    this.scrolled = true;
                }
            }
        },
        {
            key: "scrollToRestoredPosition",
            value: function scrollToRestoredPosition() {
                var scrollPosition = this.restorationData.scrollPosition;
                if (scrollPosition) {
                    this.view.scrollToPosition(scrollPosition);
                    return true;
                }
            }
        },
        {
            key: "scrollToAnchor",
            value: function scrollToAnchor() {
                var anchor = getAnchor(this.location);
                if (anchor != null) {
                    this.view.scrollToAnchor(anchor);
                    return true;
                }
            }
        },
        {
            key: "recordTimingMetric",
            value: function recordTimingMetric(metric) {
                this.timingMetrics[metric] = new Date().getTime();
            }
        },
        {
            key: "getTimingMetrics",
            value: function getTimingMetrics() {
                return Object.assign({}, this.timingMetrics);
            }
        },
        {
            key: "getHistoryMethodForAction",
            value: function getHistoryMethodForAction(action) {
                switch(action){
                    case "replace":
                        return history.replaceState;
                    case "advance":
                    case "restore":
                        return history.pushState;
                }
            }
        },
        {
            key: "hasPreloadedResponse",
            value: function hasPreloadedResponse() {
                return typeof this.response == "object";
            }
        },
        {
            key: "shouldIssueRequest",
            value: function shouldIssueRequest() {
                if (this.isSamePage) return false;
                else if (this.action == "restore") return !this.hasCachedSnapshot();
                else return this.willRender;
            }
        },
        {
            key: "cacheSnapshot",
            value: function cacheSnapshot() {
                var _this = this;
                if (!this.snapshotCached) {
                    this.view.cacheSnapshot(this.snapshot).then(function(snapshot) {
                        return snapshot && _this.visitCachedSnapshot(snapshot);
                    });
                    this.snapshotCached = true;
                }
            }
        },
        {
            key: "render",
            value: function render(callback) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.cancelRender();
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.frame = requestAnimationFrame(function() {
                                            return resolve();
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    callback()
                                ];
                            case 2:
                                _state.sent();
                                delete _this.frame;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "cancelRender",
            value: function cancelRender() {
                if (this.frame) {
                    cancelAnimationFrame(this.frame);
                    delete this.frame;
                }
            }
        }
    ]);
    return Visit;
}();
function isSuccessful(statusCode) {
    return statusCode >= 200 && statusCode < 300;
}
var BrowserAdapter = /*#__PURE__*/ function() {
    "use strict";
    function BrowserAdapter(session) {
        var _this = this;
        (0, $9j09T._)(this, BrowserAdapter);
        this.progressBar = new ProgressBar();
        this.showProgressBar = function() {
            _this.progressBar.show();
        };
        this.session = session;
    }
    (0, $eDeHT._)(BrowserAdapter, [
        {
            key: "visitProposedToLocation",
            value: function visitProposedToLocation(location1, options) {
                this.navigator.startVisit(location1, (options === null || options === void 0 ? void 0 : options.restorationIdentifier) || uuid(), options);
            }
        },
        {
            key: "visitStarted",
            value: function visitStarted(visit) {
                this.location = visit.location;
                visit.loadCachedSnapshot();
                visit.issueRequest();
                visit.goToSamePageAnchor();
            }
        },
        {
            key: "visitRequestStarted",
            value: function visitRequestStarted(visit) {
                this.progressBar.setValue(0);
                if (visit.hasCachedSnapshot() || visit.action != "restore") this.showVisitProgressBarAfterDelay();
                else this.showProgressBar();
            }
        },
        {
            key: "visitRequestCompleted",
            value: function visitRequestCompleted(visit) {
                visit.loadResponse();
            }
        },
        {
            key: "visitRequestFailedWithStatusCode",
            value: function visitRequestFailedWithStatusCode(visit, statusCode) {
                switch(statusCode){
                    case SystemStatusCode.networkFailure:
                    case SystemStatusCode.timeoutFailure:
                    case SystemStatusCode.contentTypeMismatch:
                        return this.reload({
                            reason: "request_failed",
                            context: {
                                statusCode: statusCode
                            }
                        });
                    default:
                        return visit.loadResponse();
                }
            }
        },
        {
            key: "visitRequestFinished",
            value: function visitRequestFinished(_visit) {
                this.progressBar.setValue(1);
                this.hideVisitProgressBar();
            }
        },
        {
            key: "visitCompleted",
            value: function visitCompleted(_visit) {}
        },
        {
            key: "pageInvalidated",
            value: function pageInvalidated(reason) {
                this.reload(reason);
            }
        },
        {
            key: "visitFailed",
            value: function visitFailed(_visit) {}
        },
        {
            key: "visitRendered",
            value: function visitRendered(_visit) {}
        },
        {
            key: "formSubmissionStarted",
            value: function formSubmissionStarted(_formSubmission) {
                this.progressBar.setValue(0);
                this.showFormProgressBarAfterDelay();
            }
        },
        {
            key: "formSubmissionFinished",
            value: function formSubmissionFinished(_formSubmission) {
                this.progressBar.setValue(1);
                this.hideFormProgressBar();
            }
        },
        {
            key: "showVisitProgressBarAfterDelay",
            value: function showVisitProgressBarAfterDelay() {
                this.visitProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
            }
        },
        {
            key: "hideVisitProgressBar",
            value: function hideVisitProgressBar() {
                this.progressBar.hide();
                if (this.visitProgressBarTimeout != null) {
                    window.clearTimeout(this.visitProgressBarTimeout);
                    delete this.visitProgressBarTimeout;
                }
            }
        },
        {
            key: "showFormProgressBarAfterDelay",
            value: function showFormProgressBarAfterDelay() {
                if (this.formProgressBarTimeout == null) this.formProgressBarTimeout = window.setTimeout(this.showProgressBar, this.session.progressBarDelay);
            }
        },
        {
            key: "hideFormProgressBar",
            value: function hideFormProgressBar() {
                this.progressBar.hide();
                if (this.formProgressBarTimeout != null) {
                    window.clearTimeout(this.formProgressBarTimeout);
                    delete this.formProgressBarTimeout;
                }
            }
        },
        {
            key: "reload",
            value: function reload(reason) {
                var _a;
                dispatch("turbo:reload", {
                    detail: reason
                });
                window.location.href = ((_a = this.location) === null || _a === void 0 ? void 0 : _a.toString()) || window.location.href;
            }
        },
        {
            key: "navigator",
            get: function get() {
                return this.session.navigator;
            }
        }
    ]);
    return BrowserAdapter;
}();
var CacheObserver = /*#__PURE__*/ function() {
    "use strict";
    function CacheObserver() {
        var _this = this;
        (0, $9j09T._)(this, CacheObserver);
        this.selector = "[data-turbo-temporary]";
        this.deprecatedSelector = "[data-turbo-cache=false]";
        this.started = false;
        this.removeTemporaryElements = function(_event) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.temporaryElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var element = _step.value;
                    element.remove();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }
    (0, $eDeHT._)(CacheObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    addEventListener("turbo:before-cache", this.removeTemporaryElements, false);
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    removeEventListener("turbo:before-cache", this.removeTemporaryElements, false);
                }
            }
        },
        {
            key: "temporaryElements",
            get: function get() {
                return (0, $enL5v._)(document.querySelectorAll(this.selector)).concat((0, $enL5v._)(this.temporaryElementsWithDeprecation));
            }
        },
        {
            key: "temporaryElementsWithDeprecation",
            get: function get() {
                var elements = document.querySelectorAll(this.deprecatedSelector);
                if (elements.length) console.warn("The ".concat(this.deprecatedSelector, " selector is deprecated and will be removed in a future version. Use ").concat(this.selector, " instead."));
                return (0, $enL5v._)(elements);
            }
        }
    ]);
    return CacheObserver;
}();
var FrameRedirector = /*#__PURE__*/ function() {
    "use strict";
    function FrameRedirector(session, element) {
        (0, $9j09T._)(this, FrameRedirector);
        this.session = session;
        this.element = element;
        this.linkInterceptor = new LinkInterceptor(this, element);
        this.formSubmitObserver = new FormSubmitObserver(this, element);
    }
    (0, $eDeHT._)(FrameRedirector, [
        {
            key: "start",
            value: function start() {
                this.linkInterceptor.start();
                this.formSubmitObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.linkInterceptor.stop();
                this.formSubmitObserver.stop();
            }
        },
        {
            key: "shouldInterceptLinkClick",
            value: function shouldInterceptLinkClick(element, _location, _event) {
                return this.shouldRedirect(element);
            }
        },
        {
            key: "linkClickIntercepted",
            value: function linkClickIntercepted(element, url, event) {
                var frame = this.findFrameElement(element);
                if (frame) frame.delegate.linkClickIntercepted(element, url, event);
            }
        },
        {
            key: "willSubmitForm",
            value: function willSubmitForm(element, submitter) {
                return element.closest("turbo-frame") == null && this.shouldSubmit(element, submitter) && this.shouldRedirect(element, submitter);
            }
        },
        {
            key: "formSubmitted",
            value: function formSubmitted(element, submitter) {
                var frame = this.findFrameElement(element, submitter);
                if (frame) frame.delegate.formSubmitted(element, submitter);
            }
        },
        {
            key: "shouldSubmit",
            value: function shouldSubmit(form, submitter) {
                var _a;
                var action = getAction(form, submitter);
                var meta = this.element.ownerDocument.querySelector('meta[name="turbo-root"]');
                var rootLocation = expandURL((_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/");
                return this.shouldRedirect(form, submitter) && locationIsVisitable(action, rootLocation);
            }
        },
        {
            key: "shouldRedirect",
            value: function shouldRedirect(element, submitter) {
                var isNavigatable = element instanceof HTMLFormElement ? this.session.submissionIsNavigatable(element, submitter) : this.session.elementIsNavigatable(element);
                if (isNavigatable) {
                    var frame = this.findFrameElement(element, submitter);
                    return frame ? frame != element.closest("turbo-frame") : false;
                } else return false;
            }
        },
        {
            key: "findFrameElement",
            value: function findFrameElement(element, submitter) {
                var id = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("data-turbo-frame")) || element.getAttribute("data-turbo-frame");
                if (id && id != "_top") {
                    var frame = this.element.querySelector("#".concat(id, ":not([disabled])"));
                    if (frame instanceof FrameElement) return frame;
                }
            }
        }
    ]);
    return FrameRedirector;
}();
var History = /*#__PURE__*/ function() {
    "use strict";
    function History(delegate) {
        var _this = this;
        (0, $9j09T._)(this, History);
        this.restorationIdentifier = uuid();
        this.restorationData = {};
        this.started = false;
        this.pageLoaded = false;
        this.onPopState = function(event) {
            if (_this.shouldHandlePopState()) {
                var turbo = (event.state || {}).turbo;
                if (turbo) {
                    _this.location = new URL(window.location.href);
                    var restorationIdentifier = turbo.restorationIdentifier;
                    _this.restorationIdentifier = restorationIdentifier;
                    _this.delegate.historyPoppedToLocationWithRestorationIdentifier(_this.location, restorationIdentifier);
                }
            }
        };
        var _this1 = this;
        this.onPageLoad = function() {
            var _ref = (0, $jpnpo._)(function(_event) {
                return (0, $itJXR.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                nextMicrotask()
                            ];
                        case 1:
                            _state.sent();
                            _this1.pageLoaded = true;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(_event) {
                return _ref.apply(this, arguments);
            };
        }();
        this.delegate = delegate;
    }
    (0, $eDeHT._)(History, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    addEventListener("popstate", this.onPopState, false);
                    addEventListener("load", this.onPageLoad, false);
                    this.started = true;
                    this.replace(new URL(window.location.href));
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    removeEventListener("popstate", this.onPopState, false);
                    removeEventListener("load", this.onPageLoad, false);
                    this.started = false;
                }
            }
        },
        {
            key: "push",
            value: function push(location1, restorationIdentifier) {
                this.update(history.pushState, location1, restorationIdentifier);
            }
        },
        {
            key: "replace",
            value: function replace(location1, restorationIdentifier) {
                this.update(history.replaceState, location1, restorationIdentifier);
            }
        },
        {
            key: "update",
            value: function update(method, location1) {
                var restorationIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : uuid();
                var state = {
                    turbo: {
                        restorationIdentifier: restorationIdentifier
                    }
                };
                method.call(history, state, "", location1.href);
                this.location = location1;
                this.restorationIdentifier = restorationIdentifier;
            }
        },
        {
            key: "getRestorationDataForIdentifier",
            value: function getRestorationDataForIdentifier(restorationIdentifier) {
                return this.restorationData[restorationIdentifier] || {};
            }
        },
        {
            key: "updateRestorationData",
            value: function updateRestorationData(additionalData) {
                var restorationIdentifier = this.restorationIdentifier;
                var restorationData = this.restorationData[restorationIdentifier];
                this.restorationData[restorationIdentifier] = Object.assign(Object.assign({}, restorationData), additionalData);
            }
        },
        {
            key: "assumeControlOfScrollRestoration",
            value: function assumeControlOfScrollRestoration() {
                var _a;
                if (!this.previousScrollRestoration) {
                    this.previousScrollRestoration = (_a = history.scrollRestoration) !== null && _a !== void 0 ? _a : "auto";
                    history.scrollRestoration = "manual";
                }
            }
        },
        {
            key: "relinquishControlOfScrollRestoration",
            value: function relinquishControlOfScrollRestoration() {
                if (this.previousScrollRestoration) {
                    history.scrollRestoration = this.previousScrollRestoration;
                    delete this.previousScrollRestoration;
                }
            }
        },
        {
            key: "shouldHandlePopState",
            value: function shouldHandlePopState() {
                return this.pageIsLoaded();
            }
        },
        {
            key: "pageIsLoaded",
            value: function pageIsLoaded() {
                return this.pageLoaded || document.readyState == "complete";
            }
        }
    ]);
    return History;
}();
var Navigator = /*#__PURE__*/ function() {
    "use strict";
    function Navigator(delegate) {
        (0, $9j09T._)(this, Navigator);
        this.delegate = delegate;
    }
    (0, $eDeHT._)(Navigator, [
        {
            key: "proposeVisit",
            value: function proposeVisit(location1) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.delegate.allowsVisitingLocationWithAction(location1, options.action)) {
                    if (locationIsVisitable(location1, this.view.snapshot.rootLocation)) this.delegate.visitProposedToLocation(location1, options);
                    else window.location.href = location1.toString();
                }
            }
        },
        {
            key: "startVisit",
            value: function startVisit(locatable, restorationIdentifier) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.stop();
                this.currentVisit = new Visit(this, expandURL(locatable), restorationIdentifier, Object.assign({
                    referrer: this.location
                }, options));
                this.currentVisit.start();
            }
        },
        {
            key: "submitForm",
            value: function submitForm(form, submitter) {
                this.stop();
                this.formSubmission = new FormSubmission(this, form, submitter, true);
                this.formSubmission.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.formSubmission) {
                    this.formSubmission.stop();
                    delete this.formSubmission;
                }
                if (this.currentVisit) {
                    this.currentVisit.cancel();
                    delete this.currentVisit;
                }
            }
        },
        {
            key: "adapter",
            get: function get() {
                return this.delegate.adapter;
            }
        },
        {
            key: "view",
            get: function get() {
                return this.delegate.view;
            }
        },
        {
            key: "history",
            get: function get() {
                return this.delegate.history;
            }
        },
        {
            key: "formSubmissionStarted",
            value: function formSubmissionStarted(formSubmission) {
                if (typeof this.adapter.formSubmissionStarted === "function") this.adapter.formSubmissionStarted(formSubmission);
            }
        },
        {
            key: "formSubmissionSucceededWithResponse",
            value: function formSubmissionSucceededWithResponse(formSubmission, fetchResponse) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var responseHTML, shouldCacheSnapshot, statusCode, redirected, action, visitOptions;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(formSubmission == _this.formSubmission)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    fetchResponse.responseHTML
                                ];
                            case 1:
                                responseHTML = _state.sent();
                                if (responseHTML) {
                                    shouldCacheSnapshot = formSubmission.isSafe;
                                    if (!shouldCacheSnapshot) _this.view.clearSnapshotCache();
                                    statusCode = fetchResponse.statusCode, redirected = fetchResponse.redirected;
                                    action = _this.getActionForFormSubmission(formSubmission);
                                    visitOptions = {
                                        action: action,
                                        shouldCacheSnapshot: shouldCacheSnapshot,
                                        response: {
                                            statusCode: statusCode,
                                            responseHTML: responseHTML,
                                            redirected: redirected
                                        }
                                    };
                                    _this.proposeVisit(fetchResponse.location, visitOptions);
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "formSubmissionFailedWithResponse",
            value: function formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var responseHTML, snapshot;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    fetchResponse.responseHTML
                                ];
                            case 1:
                                responseHTML = _state.sent();
                                if (!responseHTML) return [
                                    3,
                                    6
                                ];
                                snapshot = PageSnapshot.fromHTMLString(responseHTML);
                                if (!fetchResponse.serverError) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.view.renderError(snapshot, _this.currentVisit)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.view.renderPage(snapshot, false, true, _this.currentVisit)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _this.view.scrollToTop();
                                _this.view.clearSnapshotCache();
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "formSubmissionErrored",
            value: function formSubmissionErrored(formSubmission, error) {
                console.error(error);
            }
        },
        {
            key: "formSubmissionFinished",
            value: function formSubmissionFinished(formSubmission) {
                if (typeof this.adapter.formSubmissionFinished === "function") this.adapter.formSubmissionFinished(formSubmission);
            }
        },
        {
            key: "visitStarted",
            value: function visitStarted(visit) {
                this.delegate.visitStarted(visit);
            }
        },
        {
            key: "visitCompleted",
            value: function visitCompleted(visit) {
                this.delegate.visitCompleted(visit);
            }
        },
        {
            key: "locationWithActionIsSamePage",
            value: function locationWithActionIsSamePage(location1, action) {
                var anchor = getAnchor(location1);
                var currentAnchor = getAnchor(this.view.lastRenderedLocation);
                var isRestorationToTop = action === "restore" && typeof anchor === "undefined";
                return action !== "replace" && getRequestURL(location1) === getRequestURL(this.view.lastRenderedLocation) && (isRestorationToTop || anchor != null && anchor !== currentAnchor);
            }
        },
        {
            key: "visitScrolledToSamePageLocation",
            value: function visitScrolledToSamePageLocation(oldURL, newURL) {
                this.delegate.visitScrolledToSamePageLocation(oldURL, newURL);
            }
        },
        {
            key: "location",
            get: function get() {
                return this.history.location;
            }
        },
        {
            key: "restorationIdentifier",
            get: function get() {
                return this.history.restorationIdentifier;
            }
        },
        {
            key: "getActionForFormSubmission",
            value: function getActionForFormSubmission(param) {
                var submitter = param.submitter, formElement = param.formElement;
                return getVisitAction(submitter, formElement) || "advance";
            }
        }
    ]);
    return Navigator;
}();
var PageStage;
(function(PageStage) {
    PageStage[PageStage["initial"] = 0] = "initial";
    PageStage[PageStage["loading"] = 1] = "loading";
    PageStage[PageStage["interactive"] = 2] = "interactive";
    PageStage[PageStage["complete"] = 3] = "complete";
})(PageStage || (PageStage = {}));
var PageObserver = /*#__PURE__*/ function() {
    "use strict";
    function PageObserver(delegate) {
        var _this = this;
        (0, $9j09T._)(this, PageObserver);
        this.stage = PageStage.initial;
        this.started = false;
        this.interpretReadyState = function() {
            var readyState = _this.readyState;
            if (readyState == "interactive") _this.pageIsInteractive();
            else if (readyState == "complete") _this.pageIsComplete();
        };
        this.pageWillUnload = function() {
            _this.delegate.pageWillUnload();
        };
        this.delegate = delegate;
    }
    (0, $eDeHT._)(PageObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    if (this.stage == PageStage.initial) this.stage = PageStage.loading;
                    document.addEventListener("readystatechange", this.interpretReadyState, false);
                    addEventListener("pagehide", this.pageWillUnload, false);
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    document.removeEventListener("readystatechange", this.interpretReadyState, false);
                    removeEventListener("pagehide", this.pageWillUnload, false);
                    this.started = false;
                }
            }
        },
        {
            key: "pageIsInteractive",
            value: function pageIsInteractive() {
                if (this.stage == PageStage.loading) {
                    this.stage = PageStage.interactive;
                    this.delegate.pageBecameInteractive();
                }
            }
        },
        {
            key: "pageIsComplete",
            value: function pageIsComplete() {
                this.pageIsInteractive();
                if (this.stage == PageStage.interactive) {
                    this.stage = PageStage.complete;
                    this.delegate.pageLoaded();
                }
            }
        },
        {
            key: "readyState",
            get: function get() {
                return document.readyState;
            }
        }
    ]);
    return PageObserver;
}();
var ScrollObserver = /*#__PURE__*/ function() {
    "use strict";
    function ScrollObserver(delegate) {
        var _this = this;
        (0, $9j09T._)(this, ScrollObserver);
        this.started = false;
        this.onScroll = function() {
            _this.updatePosition({
                x: window.pageXOffset,
                y: window.pageYOffset
            });
        };
        this.delegate = delegate;
    }
    (0, $eDeHT._)(ScrollObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    addEventListener("scroll", this.onScroll, false);
                    this.onScroll();
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    removeEventListener("scroll", this.onScroll, false);
                    this.started = false;
                }
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(position) {
                this.delegate.scrollPositionChanged(position);
            }
        }
    ]);
    return ScrollObserver;
}();
var StreamMessageRenderer = /*#__PURE__*/ function() {
    "use strict";
    function StreamMessageRenderer() {
        (0, $9j09T._)(this, StreamMessageRenderer);
    }
    (0, $eDeHT._)(StreamMessageRenderer, [
        {
            key: "render",
            value: function render(param) {
                var fragment = param.fragment;
                Bardo.preservingPermanentElements(this, getPermanentElementMapForFragment(fragment), function() {
                    return document.documentElement.appendChild(fragment);
                });
            }
        },
        {
            key: "enteringBardo",
            value: function enteringBardo(currentPermanentElement, newPermanentElement) {
                newPermanentElement.replaceWith(currentPermanentElement.cloneNode(true));
            }
        },
        {
            key: "leavingBardo",
            value: function leavingBardo() {}
        }
    ]);
    return StreamMessageRenderer;
}();
function getPermanentElementMapForFragment(fragment) {
    var permanentElementsInDocument = queryPermanentElementsAll(document.documentElement);
    var permanentElementMap = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = permanentElementsInDocument[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var permanentElementInDocument = _step.value;
            var id = permanentElementInDocument.id;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = fragment.querySelectorAll("turbo-stream")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var streamElement = _step1.value;
                    var elementInStream = getPermanentElementById(streamElement.templateElement.content, id);
                    if (elementInStream) permanentElementMap[id] = [
                        permanentElementInDocument,
                        elementInStream
                    ];
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return permanentElementMap;
}
var StreamObserver = /*#__PURE__*/ function() {
    "use strict";
    function StreamObserver(delegate) {
        var _this = this;
        (0, $9j09T._)(this, StreamObserver);
        this.sources = new Set();
        this.started = false;
        this.inspectFetchResponse = function(event) {
            var response = fetchResponseFromEvent(event);
            if (response && fetchResponseIsStream(response)) {
                event.preventDefault();
                _this.receiveMessageResponse(response);
            }
        };
        this.receiveMessageEvent = function(event) {
            if (_this.started && typeof event.data == "string") _this.receiveMessageHTML(event.data);
        };
        this.delegate = delegate;
    }
    (0, $eDeHT._)(StreamObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    addEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    removeEventListener("turbo:before-fetch-response", this.inspectFetchResponse, false);
                }
            }
        },
        {
            key: "connectStreamSource",
            value: function connectStreamSource(source) {
                if (!this.streamSourceIsConnected(source)) {
                    this.sources.add(source);
                    source.addEventListener("message", this.receiveMessageEvent, false);
                }
            }
        },
        {
            key: "disconnectStreamSource",
            value: function disconnectStreamSource(source) {
                if (this.streamSourceIsConnected(source)) {
                    this.sources.delete(source);
                    source.removeEventListener("message", this.receiveMessageEvent, false);
                }
            }
        },
        {
            key: "streamSourceIsConnected",
            value: function streamSourceIsConnected(source) {
                return this.sources.has(source);
            }
        },
        {
            key: "receiveMessageResponse",
            value: function receiveMessageResponse(response) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var html;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    response.responseHTML
                                ];
                            case 1:
                                html = _state.sent();
                                if (html) _this.receiveMessageHTML(html);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "receiveMessageHTML",
            value: function receiveMessageHTML(html) {
                this.delegate.receivedMessageFromStream(StreamMessage.wrap(html));
            }
        }
    ]);
    return StreamObserver;
}();
function fetchResponseFromEvent(event) {
    var _a;
    var fetchResponse = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.fetchResponse;
    if (fetchResponse instanceof FetchResponse) return fetchResponse;
}
function fetchResponseIsStream(response) {
    var _a;
    var contentType = (_a = response.contentType) !== null && _a !== void 0 ? _a : "";
    return contentType.startsWith(StreamMessage.contentType);
}
var ErrorRenderer = /*#__PURE__*/ function(Renderer) {
    "use strict";
    (0, $i0LXg._)(ErrorRenderer, Renderer);
    var _super = (0, $a1vXf._)(ErrorRenderer);
    function ErrorRenderer() {
        (0, $9j09T._)(this, ErrorRenderer);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(ErrorRenderer, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        _this.replaceHeadAndBody();
                        _this.activateScriptElements();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "replaceHeadAndBody",
            value: function replaceHeadAndBody() {
                var documentElement = document.documentElement, head = document.head;
                documentElement.replaceChild(this.newHead, head);
                this.renderElement(this.currentElement, this.newElement);
            }
        },
        {
            key: "activateScriptElements",
            value: function activateScriptElements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.scriptElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var replaceableElement = _step.value;
                        var parentNode = replaceableElement.parentNode;
                        if (parentNode) {
                            var element = activateScriptElement(replaceableElement);
                            parentNode.replaceChild(element, replaceableElement);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "newHead",
            get: function get() {
                return this.newSnapshot.headSnapshot.element;
            }
        },
        {
            key: "scriptElements",
            get: function get() {
                return document.documentElement.querySelectorAll("script");
            }
        }
    ], [
        {
            key: "renderElement",
            value: function renderElement(currentElement, newElement) {
                var documentElement = document.documentElement, body = document.body;
                documentElement.replaceChild(newElement, body);
            }
        }
    ]);
    return ErrorRenderer;
}(Renderer);
var PageRenderer = /*#__PURE__*/ function(Renderer) {
    "use strict";
    (0, $i0LXg._)(PageRenderer, Renderer);
    var _super = (0, $a1vXf._)(PageRenderer);
    function PageRenderer() {
        (0, $9j09T._)(this, PageRenderer);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(PageRenderer, [
        {
            key: "shouldRender",
            get: function get() {
                return this.newSnapshot.isVisitable && this.trackedElementsAreIdentical;
            }
        },
        {
            key: "reloadReason",
            get: function get() {
                if (!this.newSnapshot.isVisitable) return {
                    reason: "turbo_visit_control_is_reload"
                };
                if (!this.trackedElementsAreIdentical) return {
                    reason: "tracked_element_mismatch"
                };
            }
        },
        {
            key: "prepareToRender",
            value: function prepareToRender() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.mergeHead()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.willRender) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.replaceBody()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "finishRendering",
            value: function finishRendering() {
                (0, $15W2b._)((0, $711He._)(PageRenderer.prototype), "finishRendering", this).call(this);
                if (!this.isPreview) this.focusFirstAutofocusableElement();
            }
        },
        {
            key: "currentHeadSnapshot",
            get: function get() {
                return this.currentSnapshot.headSnapshot;
            }
        },
        {
            key: "newHeadSnapshot",
            get: function get() {
                return this.newSnapshot.headSnapshot;
            }
        },
        {
            key: "newElement",
            get: function get() {
                return this.newSnapshot.element;
            }
        },
        {
            key: "mergeHead",
            value: function mergeHead() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var mergedHeadElements, newStylesheetElements;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mergedHeadElements = _this.mergeProvisionalElements();
                                newStylesheetElements = _this.copyNewHeadStylesheetElements();
                                _this.copyNewHeadScriptElements();
                                return [
                                    4,
                                    mergedHeadElements
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    newStylesheetElements
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "replaceBody",
            value: function replaceBody() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.preservingPermanentElements(/*#__PURE__*/ (0, $jpnpo._)(function() {
                                        return (0, $itJXR.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    _this.activateNewBody();
                                                    return [
                                                        4,
                                                        _this.assignNewBody()
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "trackedElementsAreIdentical",
            get: function get() {
                return this.currentHeadSnapshot.trackedElementSignature == this.newHeadSnapshot.trackedElementSignature;
            }
        },
        {
            key: "copyNewHeadStylesheetElements",
            value: function copyNewHeadStylesheetElements() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var loadingElements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                loadingElements = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = _this.newHeadStylesheetElements[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        element = _step.value;
                                        loadingElements.push(waitForLoad(element));
                                        document.head.appendChild(element);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    4,
                                    Promise.all(loadingElements)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "copyNewHeadScriptElements",
            value: function copyNewHeadScriptElements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.newHeadScriptElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        document.head.appendChild(activateScriptElement(element));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "mergeProvisionalElements",
            value: function mergeProvisionalElements() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var newHeadElements, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, element1;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        newHeadElements = (0, $enL5v._)(_this.newHeadProvisionalElements);
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = _this.currentHeadProvisionalElements[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                element = _step.value;
                                if (!_this.isCurrentElementInElementList(element, newHeadElements)) document.head.removeChild(element);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(_iterator1 = newHeadElements[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                element1 = _step1.value;
                                document.head.appendChild(element1);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "isCurrentElementInElementList",
            value: function isCurrentElementInElementList(element, elementList) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = elementList.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $fyOZQ._)(_step.value, 2), index = _step_value[0], newElement = _step_value[1];
                        if (element.tagName == "TITLE") {
                            if (newElement.tagName != "TITLE") continue;
                            if (element.innerHTML == newElement.innerHTML) {
                                elementList.splice(index, 1);
                                return true;
                            }
                        }
                        if (newElement.isEqualNode(element)) {
                            elementList.splice(index, 1);
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            key: "removeCurrentHeadProvisionalElements",
            value: function removeCurrentHeadProvisionalElements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.currentHeadProvisionalElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        document.head.removeChild(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "copyNewHeadProvisionalElements",
            value: function copyNewHeadProvisionalElements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.newHeadProvisionalElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        document.head.appendChild(element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "activateNewBody",
            value: function activateNewBody() {
                document.adoptNode(this.newElement);
                this.activateNewBodyScriptElements();
            }
        },
        {
            key: "activateNewBodyScriptElements",
            value: function activateNewBodyScriptElements() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.newBodyScriptElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var inertScriptElement = _step.value;
                        var activatedScriptElement = activateScriptElement(inertScriptElement);
                        inertScriptElement.replaceWith(activatedScriptElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "assignNewBody",
            value: function assignNewBody() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.renderElement(_this.currentElement, _this.newElement)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "newHeadStylesheetElements",
            get: function get() {
                return this.newHeadSnapshot.getStylesheetElementsNotInSnapshot(this.currentHeadSnapshot);
            }
        },
        {
            key: "newHeadScriptElements",
            get: function get() {
                return this.newHeadSnapshot.getScriptElementsNotInSnapshot(this.currentHeadSnapshot);
            }
        },
        {
            key: "currentHeadProvisionalElements",
            get: function get() {
                return this.currentHeadSnapshot.provisionalElements;
            }
        },
        {
            key: "newHeadProvisionalElements",
            get: function get() {
                return this.newHeadSnapshot.provisionalElements;
            }
        },
        {
            key: "newBodyScriptElements",
            get: function get() {
                return this.newElement.querySelectorAll("script");
            }
        }
    ], [
        {
            key: "renderElement",
            value: function renderElement(currentElement, newElement) {
                if (document.body && newElement instanceof HTMLBodyElement) document.body.replaceWith(newElement);
                else document.documentElement.appendChild(newElement);
            }
        }
    ]);
    return PageRenderer;
}(Renderer);
var SnapshotCache = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotCache(size) {
        (0, $9j09T._)(this, SnapshotCache);
        this.keys = [];
        this.snapshots = {};
        this.size = size;
    }
    (0, $eDeHT._)(SnapshotCache, [
        {
            key: "has",
            value: function has(location1) {
                return toCacheKey(location1) in this.snapshots;
            }
        },
        {
            key: "get",
            value: function get(location1) {
                if (this.has(location1)) {
                    var snapshot = this.read(location1);
                    this.touch(location1);
                    return snapshot;
                }
            }
        },
        {
            key: "put",
            value: function put(location1, snapshot) {
                this.write(location1, snapshot);
                this.touch(location1);
                return snapshot;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.snapshots = {};
            }
        },
        {
            key: "read",
            value: function read(location1) {
                return this.snapshots[toCacheKey(location1)];
            }
        },
        {
            key: "write",
            value: function write(location1, snapshot) {
                this.snapshots[toCacheKey(location1)] = snapshot;
            }
        },
        {
            key: "touch",
            value: function touch(location1) {
                var key = toCacheKey(location1);
                var index = this.keys.indexOf(key);
                if (index > -1) this.keys.splice(index, 1);
                this.keys.unshift(key);
                this.trim();
            }
        },
        {
            key: "trim",
            value: function trim() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.keys.splice(this.size)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        delete this.snapshots[key];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return SnapshotCache;
}();
var PageView = /*#__PURE__*/ function(View) {
    "use strict";
    (0, $i0LXg._)(PageView, View);
    var _super = (0, $a1vXf._)(PageView);
    function PageView() {
        (0, $9j09T._)(this, PageView);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.snapshotCache = new SnapshotCache(10);
        _this.lastRenderedLocation = new URL(location.href);
        _this.forceReloaded = false;
        return _this;
    }
    (0, $eDeHT._)(PageView, [
        {
            key: "renderPage",
            value: function renderPage(snapshot) {
                var isPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, willRender = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, _$visit = arguments.length > 3 ? arguments[3] : void 0;
                var renderer = new PageRenderer(this.snapshot, snapshot, PageRenderer.renderElement, isPreview, willRender);
                if (!renderer.shouldRender) this.forceReloaded = true;
                else _$visit === null || _$visit === void 0 || _$visit.changeHistory();
                return this.render(renderer);
            }
        },
        {
            key: "renderError",
            value: function renderError(snapshot, visit) {
                visit === null || visit === void 0 || visit.changeHistory();
                var renderer = new ErrorRenderer(this.snapshot, snapshot, ErrorRenderer.renderElement, false);
                return this.render(renderer);
            }
        },
        {
            key: "clearSnapshotCache",
            value: function clearSnapshotCache() {
                this.snapshotCache.clear();
            }
        },
        {
            key: "cacheSnapshot",
            value: function cacheSnapshot() {
                var snapshot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.snapshot;
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var location1, cachedSnapshot;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!snapshot.isCacheable) return [
                                    3,
                                    2
                                ];
                                _this.delegate.viewWillCacheSnapshot();
                                location1 = _this.lastRenderedLocation;
                                return [
                                    4,
                                    nextEventLoopTick()
                                ];
                            case 1:
                                _state.sent();
                                cachedSnapshot = snapshot.clone();
                                _this.snapshotCache.put(location1, cachedSnapshot);
                                return [
                                    2,
                                    cachedSnapshot
                                ];
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCachedSnapshotForLocation",
            value: function getCachedSnapshotForLocation(location1) {
                return this.snapshotCache.get(location1);
            }
        },
        {
            key: "snapshot",
            get: function get() {
                return PageSnapshot.fromElement(this.element);
            }
        }
    ]);
    return PageView;
}(View);
var Preloader = /*#__PURE__*/ function() {
    "use strict";
    function Preloader(delegate) {
        (0, $9j09T._)(this, Preloader);
        this.selector = "a[data-turbo-preload]";
        this.delegate = delegate;
    }
    (0, $eDeHT._)(Preloader, [
        {
            key: "snapshotCache",
            get: function get() {
                return this.delegate.navigator.view.snapshotCache;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                if (document.readyState === "loading") return document.addEventListener("DOMContentLoaded", function() {
                    _this.preloadOnLoadLinksForView(document.body);
                });
                else this.preloadOnLoadLinksForView(document.body);
            }
        },
        {
            key: "preloadOnLoadLinksForView",
            value: function preloadOnLoadLinksForView(element) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = element.querySelectorAll(this.selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var link = _step.value;
                        this.preloadURL(link);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "preloadURL",
            value: function preloadURL(link) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var location1, response, responseText, snapshot, _;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                location1 = new URL(link.href);
                                if (_this.snapshotCache.has(location1)) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    fetch(location1.toString(), {
                                        headers: {
                                            "VND.PREFETCH": "true",
                                            Accept: "text/html"
                                        }
                                    })
                                ];
                            case 2:
                                response = _state.sent();
                                return [
                                    4,
                                    response.text()
                                ];
                            case 3:
                                responseText = _state.sent();
                                snapshot = PageSnapshot.fromHTMLString(responseText);
                                _this.snapshotCache.put(location1, snapshot);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _ = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return Preloader;
}();
var Session = /*#__PURE__*/ function() {
    "use strict";
    function Session() {
        (0, $9j09T._)(this, Session);
        this.navigator = new Navigator(this);
        this.history = new History(this);
        this.preloader = new Preloader(this);
        this.view = new PageView(this, document.documentElement);
        this.adapter = new BrowserAdapter(this);
        this.pageObserver = new PageObserver(this);
        this.cacheObserver = new CacheObserver();
        this.linkClickObserver = new LinkClickObserver(this, window);
        this.formSubmitObserver = new FormSubmitObserver(this, document);
        this.scrollObserver = new ScrollObserver(this);
        this.streamObserver = new StreamObserver(this);
        this.formLinkClickObserver = new FormLinkClickObserver(this, document.documentElement);
        this.frameRedirector = new FrameRedirector(this, document.documentElement);
        this.streamMessageRenderer = new StreamMessageRenderer();
        this.drive = true;
        this.enabled = true;
        this.progressBarDelay = 500;
        this.started = false;
        this.formMode = "on";
    }
    (0, $eDeHT._)(Session, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.pageObserver.start();
                    this.cacheObserver.start();
                    this.formLinkClickObserver.start();
                    this.linkClickObserver.start();
                    this.formSubmitObserver.start();
                    this.scrollObserver.start();
                    this.streamObserver.start();
                    this.frameRedirector.start();
                    this.history.start();
                    this.preloader.start();
                    this.started = true;
                    this.enabled = true;
                }
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.pageObserver.stop();
                    this.cacheObserver.stop();
                    this.formLinkClickObserver.stop();
                    this.linkClickObserver.stop();
                    this.formSubmitObserver.stop();
                    this.scrollObserver.stop();
                    this.streamObserver.stop();
                    this.frameRedirector.stop();
                    this.history.stop();
                    this.started = false;
                }
            }
        },
        {
            key: "registerAdapter",
            value: function registerAdapter(adapter) {
                this.adapter = adapter;
            }
        },
        {
            key: "visit",
            value: function visit(location1) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var frameElement = options.frame ? document.getElementById(options.frame) : null;
                if (frameElement instanceof FrameElement) {
                    frameElement.src = location1.toString();
                    frameElement.loaded;
                } else this.navigator.proposeVisit(expandURL(location1), options);
            }
        },
        {
            key: "connectStreamSource",
            value: function connectStreamSource(source) {
                this.streamObserver.connectStreamSource(source);
            }
        },
        {
            key: "disconnectStreamSource",
            value: function disconnectStreamSource(source) {
                this.streamObserver.disconnectStreamSource(source);
            }
        },
        {
            key: "renderStreamMessage",
            value: function renderStreamMessage(message) {
                this.streamMessageRenderer.render(StreamMessage.wrap(message));
            }
        },
        {
            key: "clearCache",
            value: function clearCache() {
                this.view.clearSnapshotCache();
            }
        },
        {
            key: "setProgressBarDelay",
            value: function setProgressBarDelay(delay) {
                this.progressBarDelay = delay;
            }
        },
        {
            key: "setFormMode",
            value: function setFormMode(mode) {
                this.formMode = mode;
            }
        },
        {
            key: "location",
            get: function get() {
                return this.history.location;
            }
        },
        {
            key: "restorationIdentifier",
            get: function get() {
                return this.history.restorationIdentifier;
            }
        },
        {
            key: "historyPoppedToLocationWithRestorationIdentifier",
            value: function historyPoppedToLocationWithRestorationIdentifier(location1, restorationIdentifier) {
                if (this.enabled) this.navigator.startVisit(location1, restorationIdentifier, {
                    action: "restore",
                    historyChanged: true
                });
                else this.adapter.pageInvalidated({
                    reason: "turbo_disabled"
                });
            }
        },
        {
            key: "scrollPositionChanged",
            value: function scrollPositionChanged(position) {
                this.history.updateRestorationData({
                    scrollPosition: position
                });
            }
        },
        {
            key: "willSubmitFormLinkToLocation",
            value: function willSubmitFormLinkToLocation(link, location1) {
                return this.elementIsNavigatable(link) && locationIsVisitable(location1, this.snapshot.rootLocation);
            }
        },
        {
            key: "submittedFormLinkToLocation",
            value: function submittedFormLinkToLocation() {}
        },
        {
            key: "willFollowLinkToLocation",
            value: function willFollowLinkToLocation(link, location1, event) {
                return this.elementIsNavigatable(link) && locationIsVisitable(location1, this.snapshot.rootLocation) && this.applicationAllowsFollowingLinkToLocation(link, location1, event);
            }
        },
        {
            key: "followedLinkToLocation",
            value: function followedLinkToLocation(link, location1) {
                var action = this.getActionForLink(link);
                var acceptsStreamResponse = link.hasAttribute("data-turbo-stream");
                this.visit(location1.href, {
                    action: action,
                    acceptsStreamResponse: acceptsStreamResponse
                });
            }
        },
        {
            key: "allowsVisitingLocationWithAction",
            value: function allowsVisitingLocationWithAction(location1, action) {
                return this.locationWithActionIsSamePage(location1, action) || this.applicationAllowsVisitingLocation(location1);
            }
        },
        {
            key: "visitProposedToLocation",
            value: function visitProposedToLocation(location1, options) {
                extendURLWithDeprecatedProperties(location1);
                this.adapter.visitProposedToLocation(location1, options);
            }
        },
        {
            key: "visitStarted",
            value: function visitStarted(visit) {
                if (!visit.acceptsStreamResponse) markAsBusy(document.documentElement);
                extendURLWithDeprecatedProperties(visit.location);
                if (!visit.silent) this.notifyApplicationAfterVisitingLocation(visit.location, visit.action);
            }
        },
        {
            key: "visitCompleted",
            value: function visitCompleted(visit) {
                clearBusyState(document.documentElement);
                this.notifyApplicationAfterPageLoad(visit.getTimingMetrics());
            }
        },
        {
            key: "locationWithActionIsSamePage",
            value: function locationWithActionIsSamePage(location1, action) {
                return this.navigator.locationWithActionIsSamePage(location1, action);
            }
        },
        {
            key: "visitScrolledToSamePageLocation",
            value: function visitScrolledToSamePageLocation(oldURL, newURL) {
                this.notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL);
            }
        },
        {
            key: "willSubmitForm",
            value: function willSubmitForm(form, submitter) {
                var action = getAction(form, submitter);
                return this.submissionIsNavigatable(form, submitter) && locationIsVisitable(expandURL(action), this.snapshot.rootLocation);
            }
        },
        {
            key: "formSubmitted",
            value: function formSubmitted(form, submitter) {
                this.navigator.submitForm(form, submitter);
            }
        },
        {
            key: "pageBecameInteractive",
            value: function pageBecameInteractive() {
                this.view.lastRenderedLocation = this.location;
                this.notifyApplicationAfterPageLoad();
            }
        },
        {
            key: "pageLoaded",
            value: function pageLoaded() {
                this.history.assumeControlOfScrollRestoration();
            }
        },
        {
            key: "pageWillUnload",
            value: function pageWillUnload() {
                this.history.relinquishControlOfScrollRestoration();
            }
        },
        {
            key: "receivedMessageFromStream",
            value: function receivedMessageFromStream(message) {
                this.renderStreamMessage(message);
            }
        },
        {
            key: "viewWillCacheSnapshot",
            value: function viewWillCacheSnapshot() {
                var _a;
                if (!((_a = this.navigator.currentVisit) === null || _a === void 0 ? void 0 : _a.silent)) this.notifyApplicationBeforeCachingSnapshot();
            }
        },
        {
            key: "allowsImmediateRender",
            value: function allowsImmediateRender(param, options) {
                var element = param.element;
                var event = this.notifyApplicationBeforeRender(element, options);
                var defaultPrevented = event.defaultPrevented, render = event.detail.render;
                if (this.view.renderer && render) this.view.renderer.renderElement = render;
                return !defaultPrevented;
            }
        },
        {
            key: "viewRenderedSnapshot",
            value: function viewRenderedSnapshot(_snapshot, _isPreview) {
                this.view.lastRenderedLocation = this.history.location;
                this.notifyApplicationAfterRender();
            }
        },
        {
            key: "preloadOnLoadLinksForView",
            value: function preloadOnLoadLinksForView(element) {
                this.preloader.preloadOnLoadLinksForView(element);
            }
        },
        {
            key: "viewInvalidated",
            value: function viewInvalidated(reason) {
                this.adapter.pageInvalidated(reason);
            }
        },
        {
            key: "frameLoaded",
            value: function frameLoaded(frame) {
                this.notifyApplicationAfterFrameLoad(frame);
            }
        },
        {
            key: "frameRendered",
            value: function frameRendered(fetchResponse, frame) {
                this.notifyApplicationAfterFrameRender(fetchResponse, frame);
            }
        },
        {
            key: "applicationAllowsFollowingLinkToLocation",
            value: function applicationAllowsFollowingLinkToLocation(link, location1, ev) {
                var event = this.notifyApplicationAfterClickingLinkToLocation(link, location1, ev);
                return !event.defaultPrevented;
            }
        },
        {
            key: "applicationAllowsVisitingLocation",
            value: function applicationAllowsVisitingLocation(location1) {
                var event = this.notifyApplicationBeforeVisitingLocation(location1);
                return !event.defaultPrevented;
            }
        },
        {
            key: "notifyApplicationAfterClickingLinkToLocation",
            value: function notifyApplicationAfterClickingLinkToLocation(link, location1, event) {
                return dispatch("turbo:click", {
                    target: link,
                    detail: {
                        url: location1.href,
                        originalEvent: event
                    },
                    cancelable: true
                });
            }
        },
        {
            key: "notifyApplicationBeforeVisitingLocation",
            value: function notifyApplicationBeforeVisitingLocation(location1) {
                return dispatch("turbo:before-visit", {
                    detail: {
                        url: location1.href
                    },
                    cancelable: true
                });
            }
        },
        {
            key: "notifyApplicationAfterVisitingLocation",
            value: function notifyApplicationAfterVisitingLocation(location1, action) {
                return dispatch("turbo:visit", {
                    detail: {
                        url: location1.href,
                        action: action
                    }
                });
            }
        },
        {
            key: "notifyApplicationBeforeCachingSnapshot",
            value: function notifyApplicationBeforeCachingSnapshot() {
                return dispatch("turbo:before-cache");
            }
        },
        {
            key: "notifyApplicationBeforeRender",
            value: function notifyApplicationBeforeRender(newBody, options) {
                return dispatch("turbo:before-render", {
                    detail: Object.assign({
                        newBody: newBody
                    }, options),
                    cancelable: true
                });
            }
        },
        {
            key: "notifyApplicationAfterRender",
            value: function notifyApplicationAfterRender() {
                return dispatch("turbo:render");
            }
        },
        {
            key: "notifyApplicationAfterPageLoad",
            value: function notifyApplicationAfterPageLoad() {
                var timing = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return dispatch("turbo:load", {
                    detail: {
                        url: this.location.href,
                        timing: timing
                    }
                });
            }
        },
        {
            key: "notifyApplicationAfterVisitingSamePageLocation",
            value: function notifyApplicationAfterVisitingSamePageLocation(oldURL, newURL) {
                dispatchEvent(new HashChangeEvent("hashchange", {
                    oldURL: oldURL.toString(),
                    newURL: newURL.toString()
                }));
            }
        },
        {
            key: "notifyApplicationAfterFrameLoad",
            value: function notifyApplicationAfterFrameLoad(frame) {
                return dispatch("turbo:frame-load", {
                    target: frame
                });
            }
        },
        {
            key: "notifyApplicationAfterFrameRender",
            value: function notifyApplicationAfterFrameRender(fetchResponse, frame) {
                return dispatch("turbo:frame-render", {
                    detail: {
                        fetchResponse: fetchResponse
                    },
                    target: frame,
                    cancelable: true
                });
            }
        },
        {
            key: "submissionIsNavigatable",
            value: function submissionIsNavigatable(form, submitter) {
                if (this.formMode == "off") return false;
                else {
                    var submitterIsNavigatable = submitter ? this.elementIsNavigatable(submitter) : true;
                    if (this.formMode == "optin") return submitterIsNavigatable && form.closest('[data-turbo="true"]') != null;
                    else return submitterIsNavigatable && this.elementIsNavigatable(form);
                }
            }
        },
        {
            key: "elementIsNavigatable",
            value: function elementIsNavigatable(element) {
                var container = findClosestRecursively(element, "[data-turbo]");
                var withinFrame = findClosestRecursively(element, "turbo-frame");
                if (this.drive || withinFrame) {
                    if (container) return container.getAttribute("data-turbo") != "false";
                    else return true;
                } else {
                    if (container) return container.getAttribute("data-turbo") == "true";
                    else return false;
                }
            }
        },
        {
            key: "getActionForLink",
            value: function getActionForLink(link) {
                return getVisitAction(link) || "advance";
            }
        },
        {
            key: "snapshot",
            get: function get() {
                return this.view.snapshot;
            }
        }
    ]);
    return Session;
}();
function extendURLWithDeprecatedProperties(url) {
    Object.defineProperties(url, deprecatedLocationPropertyDescriptors);
}
var deprecatedLocationPropertyDescriptors = {
    absoluteURL: {
        get: function() {
            return this.toString();
        }
    }
};
var Cache = /*#__PURE__*/ function() {
    "use strict";
    function Cache(session) {
        (0, $9j09T._)(this, Cache);
        this.session = session;
    }
    (0, $eDeHT._)(Cache, [
        {
            key: "clear",
            value: function clear() {
                this.session.clearCache();
            }
        },
        {
            key: "resetCacheControl",
            value: function resetCacheControl() {
                this.setCacheControl("");
            }
        },
        {
            key: "exemptPageFromCache",
            value: function exemptPageFromCache() {
                this.setCacheControl("no-cache");
            }
        },
        {
            key: "exemptPageFromPreview",
            value: function exemptPageFromPreview() {
                this.setCacheControl("no-preview");
            }
        },
        {
            key: "setCacheControl",
            value: function setCacheControl(value) {
                setMetaContent("turbo-cache-control", value);
            }
        }
    ]);
    return Cache;
}();
var StreamActions = {
    after: function() {
        var _this = this;
        this.targetElements.forEach(function(e) {
            var _a;
            return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(_this.templateContent, e.nextSibling);
        });
    },
    append: function() {
        var _this = this;
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach(function(e) {
            return e.append(_this.templateContent);
        });
    },
    before: function() {
        var _this = this;
        this.targetElements.forEach(function(e) {
            var _a;
            return (_a = e.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(_this.templateContent, e);
        });
    },
    prepend: function() {
        var _this = this;
        this.removeDuplicateTargetChildren();
        this.targetElements.forEach(function(e) {
            return e.prepend(_this.templateContent);
        });
    },
    remove: function() {
        this.targetElements.forEach(function(e) {
            return e.remove();
        });
    },
    replace: function() {
        var _this = this;
        this.targetElements.forEach(function(e) {
            return e.replaceWith(_this.templateContent);
        });
    },
    update: function() {
        var _this = this;
        this.targetElements.forEach(function(targetElement) {
            targetElement.innerHTML = "";
            targetElement.append(_this.templateContent);
        });
    }
};
var session = new Session();
var cache = new Cache(session);
var navigator$1 = session.navigator;
function start() {
    session.start();
}
function registerAdapter(adapter) {
    session.registerAdapter(adapter);
}
function visit(location1, options) {
    session.visit(location1, options);
}
function connectStreamSource(source) {
    session.connectStreamSource(source);
}
function disconnectStreamSource(source) {
    session.disconnectStreamSource(source);
}
function renderStreamMessage(message) {
    session.renderStreamMessage(message);
}
function clearCache() {
    console.warn("Please replace `Turbo.clearCache()` with `Turbo.cache.clear()`. The top-level function is deprecated and will be removed in a future version of Turbo.`");
    session.clearCache();
}
function setProgressBarDelay(delay) {
    session.setProgressBarDelay(delay);
}
function setConfirmMethod(confirmMethod) {
    FormSubmission.confirmMethod = confirmMethod;
}
function setFormMode(mode) {
    session.setFormMode(mode);
}
var Turbo = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    navigator: navigator$1,
    session: session,
    cache: cache,
    PageRenderer: PageRenderer,
    PageSnapshot: PageSnapshot,
    FrameRenderer: FrameRenderer,
    start: start,
    registerAdapter: registerAdapter,
    visit: visit,
    connectStreamSource: connectStreamSource,
    disconnectStreamSource: disconnectStreamSource,
    renderStreamMessage: renderStreamMessage,
    clearCache: clearCache,
    setProgressBarDelay: setProgressBarDelay,
    setConfirmMethod: setConfirmMethod,
    setFormMode: setFormMode,
    StreamActions: StreamActions
});
var TurboFrameMissingError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $i0LXg._)(TurboFrameMissingError, Error1);
    var _super = (0, $a1vXf._)(TurboFrameMissingError);
    function TurboFrameMissingError() {
        (0, $9j09T._)(this, TurboFrameMissingError);
        return _super.apply(this, arguments);
    }
    return TurboFrameMissingError;
}((0, $fYvNR._)(Error));
var FrameController = /*#__PURE__*/ function() {
    "use strict";
    function FrameController(element) {
        var _this = this;
        (0, $9j09T._)(this, FrameController);
        this.fetchResponseLoaded = function(_fetchResponse) {};
        this.currentFetchRequest = null;
        this.resolveVisitPromise = function() {};
        this.connected = false;
        this.hasBeenLoaded = false;
        this.ignoredAttributes = new Set();
        this.action = null;
        this.visitCachedSnapshot = function(param) {
            var _$element = param.element;
            var _frame;
            var frame = _$element.querySelector("#" + _this.element.id);
            if (frame && _this.previousFrameElement) (_frame = frame).replaceChildren.apply(_frame, (0, $enL5v._)(_this.previousFrameElement.children));
            delete _this.previousFrameElement;
        };
        this.element = element;
        this.view = new FrameView(this, this.element);
        this.appearanceObserver = new AppearanceObserver(this, this.element);
        this.formLinkClickObserver = new FormLinkClickObserver(this, this.element);
        this.linkInterceptor = new LinkInterceptor(this, this.element);
        this.restorationIdentifier = uuid();
        this.formSubmitObserver = new FormSubmitObserver(this, this.element);
    }
    (0, $eDeHT._)(FrameController, [
        {
            key: "connect",
            value: function connect() {
                if (!this.connected) {
                    this.connected = true;
                    if (this.loadingStyle == FrameLoadingStyle.lazy) this.appearanceObserver.start();
                    else this.loadSourceURL();
                    this.formLinkClickObserver.start();
                    this.linkInterceptor.start();
                    this.formSubmitObserver.start();
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.connected) {
                    this.connected = false;
                    this.appearanceObserver.stop();
                    this.formLinkClickObserver.stop();
                    this.linkInterceptor.stop();
                    this.formSubmitObserver.stop();
                }
            }
        },
        {
            key: "disabledChanged",
            value: function disabledChanged() {
                if (this.loadingStyle == FrameLoadingStyle.eager) this.loadSourceURL();
            }
        },
        {
            key: "sourceURLChanged",
            value: function sourceURLChanged() {
                if (this.isIgnoringChangesTo("src")) return;
                if (this.element.isConnected) this.complete = false;
                if (this.loadingStyle == FrameLoadingStyle.eager || this.hasBeenLoaded) this.loadSourceURL();
            }
        },
        {
            key: "sourceURLReloaded",
            value: function sourceURLReloaded() {
                var _this = this;
                var src = this.element.src;
                this.ignoringChangesToAttribute("complete", function() {
                    _this.element.removeAttribute("complete");
                });
                this.element.src = null;
                this.element.src = src;
                return this.element.loaded;
            }
        },
        {
            key: "completeChanged",
            value: function completeChanged() {
                if (this.isIgnoringChangesTo("complete")) return;
                this.loadSourceURL();
            }
        },
        {
            key: "loadingStyleChanged",
            value: function loadingStyleChanged() {
                if (this.loadingStyle == FrameLoadingStyle.lazy) this.appearanceObserver.start();
                else {
                    this.appearanceObserver.stop();
                    this.loadSourceURL();
                }
            }
        },
        {
            key: "loadSourceURL",
            value: function loadSourceURL() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.enabled && _this.isActive && !_this.complete && _this.sourceURL)) return [
                                    3,
                                    2
                                ];
                                _this.element.loaded = _this.visit(expandURL(_this.sourceURL));
                                _this.appearanceObserver.stop();
                                return [
                                    4,
                                    _this.element.loaded
                                ];
                            case 1:
                                _state.sent();
                                _this.hasBeenLoaded = true;
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "loadResponse",
            value: function loadResponse(fetchResponse) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var html, document1, pageSnapshot;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (fetchResponse.redirected || fetchResponse.succeeded && fetchResponse.isHTML) _this.sourceURL = fetchResponse.response.url;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    7,
                                    8
                                ]);
                                return [
                                    4,
                                    fetchResponse.responseHTML
                                ];
                            case 2:
                                html = _state.sent();
                                if (!html) return [
                                    3,
                                    6
                                ];
                                document1 = parseHTMLDocument(html);
                                pageSnapshot = PageSnapshot.fromDocument(document1);
                                if (!pageSnapshot.isVisitable) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.loadFrameResponse(fetchResponse, document1)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.handleUnvisitableFrameResponse(fetchResponse)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                _this.fetchResponseLoaded = function() {};
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "elementAppearedInViewport",
            value: function elementAppearedInViewport(element) {
                this.proposeVisitIfNavigatedWithAction(element, element);
                this.loadSourceURL();
            }
        },
        {
            key: "willSubmitFormLinkToLocation",
            value: function willSubmitFormLinkToLocation(link) {
                return this.shouldInterceptNavigation(link);
            }
        },
        {
            key: "submittedFormLinkToLocation",
            value: function submittedFormLinkToLocation(link, _location, form) {
                var frame = this.findFrameElement(link);
                if (frame) form.setAttribute("data-turbo-frame", frame.id);
            }
        },
        {
            key: "shouldInterceptLinkClick",
            value: function shouldInterceptLinkClick(element, _location, _event) {
                return this.shouldInterceptNavigation(element);
            }
        },
        {
            key: "linkClickIntercepted",
            value: function linkClickIntercepted(element, location1) {
                this.navigateFrame(element, location1);
            }
        },
        {
            key: "willSubmitForm",
            value: function willSubmitForm(element, submitter) {
                return element.closest("turbo-frame") == this.element && this.shouldInterceptNavigation(element, submitter);
            }
        },
        {
            key: "formSubmitted",
            value: function formSubmitted(element, submitter) {
                if (this.formSubmission) this.formSubmission.stop();
                this.formSubmission = new FormSubmission(this, element, submitter);
                var fetchRequest = this.formSubmission.fetchRequest;
                this.prepareRequest(fetchRequest);
                this.formSubmission.start();
            }
        },
        {
            key: "prepareRequest",
            value: function prepareRequest(request) {
                var _a;
                request.headers["Turbo-Frame"] = this.id;
                if ((_a = this.currentNavigationElement) === null || _a === void 0 ? void 0 : _a.hasAttribute("data-turbo-stream")) request.acceptResponseType(StreamMessage.contentType);
            }
        },
        {
            key: "requestStarted",
            value: function requestStarted(_request) {
                markAsBusy(this.element);
            }
        },
        {
            key: "requestPreventedHandlingResponse",
            value: function requestPreventedHandlingResponse(_request, _response) {
                this.resolveVisitPromise();
            }
        },
        {
            key: "requestSucceededWithResponse",
            value: function requestSucceededWithResponse(request, response) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadResponse(response)
                                ];
                            case 1:
                                _state.sent();
                                _this.resolveVisitPromise();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestFailedWithResponse",
            value: function requestFailedWithResponse(request, response) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.loadResponse(response)
                                ];
                            case 1:
                                _state.sent();
                                _this.resolveVisitPromise();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "requestErrored",
            value: function requestErrored(request, error) {
                console.error(error);
                this.resolveVisitPromise();
            }
        },
        {
            key: "requestFinished",
            value: function requestFinished(_request) {
                clearBusyState(this.element);
            }
        },
        {
            key: "formSubmissionStarted",
            value: function formSubmissionStarted(param) {
                var formElement = param.formElement;
                markAsBusy(formElement, this.findFrameElement(formElement));
            }
        },
        {
            key: "formSubmissionSucceededWithResponse",
            value: function formSubmissionSucceededWithResponse(formSubmission, response) {
                var frame = this.findFrameElement(formSubmission.formElement, formSubmission.submitter);
                frame.delegate.proposeVisitIfNavigatedWithAction(frame, formSubmission.formElement, formSubmission.submitter);
                frame.delegate.loadResponse(response);
                if (!formSubmission.isSafe) session.clearCache();
            }
        },
        {
            key: "formSubmissionFailedWithResponse",
            value: function formSubmissionFailedWithResponse(formSubmission, fetchResponse) {
                this.element.delegate.loadResponse(fetchResponse);
                session.clearCache();
            }
        },
        {
            key: "formSubmissionErrored",
            value: function formSubmissionErrored(formSubmission, error) {
                console.error(error);
            }
        },
        {
            key: "formSubmissionFinished",
            value: function formSubmissionFinished(param) {
                var formElement = param.formElement;
                clearBusyState(formElement, this.findFrameElement(formElement));
            }
        },
        {
            key: "allowsImmediateRender",
            value: function allowsImmediateRender(param, options) {
                var newFrame = param.element;
                var event = dispatch("turbo:before-frame-render", {
                    target: this.element,
                    detail: Object.assign({
                        newFrame: newFrame
                    }, options),
                    cancelable: true
                });
                var defaultPrevented = event.defaultPrevented, render = event.detail.render;
                if (this.view.renderer && render) this.view.renderer.renderElement = render;
                return !defaultPrevented;
            }
        },
        {
            key: "viewRenderedSnapshot",
            value: function viewRenderedSnapshot(_snapshot, _isPreview) {}
        },
        {
            key: "preloadOnLoadLinksForView",
            value: function preloadOnLoadLinksForView(element) {
                session.preloadOnLoadLinksForView(element);
            }
        },
        {
            key: "viewInvalidated",
            value: function viewInvalidated() {}
        },
        {
            key: "willRenderFrame",
            value: function willRenderFrame(currentElement, _newElement) {
                this.previousFrameElement = currentElement.cloneNode(true);
            }
        },
        {
            key: "loadFrameResponse",
            value: function loadFrameResponse(fetchResponse, document1) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var newFrameElement, snapshot, renderer;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.extractForeignFrameElement(document1.body)
                                ];
                            case 1:
                                newFrameElement = _state.sent();
                                if (!newFrameElement) return [
                                    3,
                                    5
                                ];
                                snapshot = new Snapshot(newFrameElement);
                                renderer = new FrameRenderer(_this, _this.view.snapshot, snapshot, FrameRenderer.renderElement, false, false);
                                if (!_this.view.renderPromise) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.view.renderPromise
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                _this.changeHistory();
                                return [
                                    4,
                                    _this.view.render(renderer)
                                ];
                            case 4:
                                _state.sent();
                                _this.complete = true;
                                session.frameRendered(fetchResponse, _this.element);
                                session.frameLoaded(_this.element);
                                _this.fetchResponseLoaded(fetchResponse);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (_this.willHandleFrameMissingFromResponse(fetchResponse)) _this.handleFrameMissingFromResponse(fetchResponse);
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "visit",
            value: function visit(url) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var _a, request;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        request = new FetchRequest(_this, FetchMethod.get, url, new URLSearchParams(), _this.element);
                        (_a = _this.currentFetchRequest) === null || _a === void 0 || _a.cancel();
                        _this.currentFetchRequest = request;
                        return [
                            2,
                            new Promise(function(resolve) {
                                _this.resolveVisitPromise = function() {
                                    _this.resolveVisitPromise = function() {};
                                    _this.currentFetchRequest = null;
                                    resolve();
                                };
                                request.perform();
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "navigateFrame",
            value: function navigateFrame(element, url, submitter) {
                var frame = this.findFrameElement(element, submitter);
                frame.delegate.proposeVisitIfNavigatedWithAction(frame, element, submitter);
                this.withCurrentNavigationElement(element, function() {
                    frame.src = url;
                });
            }
        },
        {
            key: "proposeVisitIfNavigatedWithAction",
            value: function proposeVisitIfNavigatedWithAction(frame, element, submitter) {
                var _this = this;
                this.action = getVisitAction(submitter, element, frame);
                if (this.action) {
                    var pageSnapshot = PageSnapshot.fromElement(frame).clone();
                    var visitCachedSnapshot = frame.delegate.visitCachedSnapshot;
                    frame.delegate.fetchResponseLoaded = function(fetchResponse) {
                        if (frame.src) {
                            var statusCode = fetchResponse.statusCode, redirected = fetchResponse.redirected;
                            var responseHTML = frame.ownerDocument.documentElement.outerHTML;
                            var response = {
                                statusCode: statusCode,
                                redirected: redirected,
                                responseHTML: responseHTML
                            };
                            var options = {
                                response: response,
                                visitCachedSnapshot: visitCachedSnapshot,
                                willRender: false,
                                updateHistory: false,
                                restorationIdentifier: _this.restorationIdentifier,
                                snapshot: pageSnapshot
                            };
                            if (_this.action) options.action = _this.action;
                            session.visit(frame.src, options);
                        }
                    };
                }
            }
        },
        {
            key: "changeHistory",
            value: function changeHistory() {
                if (this.action) {
                    var method = getHistoryMethodForAction(this.action);
                    session.history.update(method, expandURL(this.element.src || ""), this.restorationIdentifier);
                }
            }
        },
        {
            key: "handleUnvisitableFrameResponse",
            value: function handleUnvisitableFrameResponse(fetchResponse) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.warn("The response (".concat(fetchResponse.statusCode, ') from <turbo-frame id="').concat(_this.element.id, '"> is performing a full page visit due to turbo-visit-control.'));
                                return [
                                    4,
                                    _this.visitResponse(fetchResponse.response)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "willHandleFrameMissingFromResponse",
            value: function willHandleFrameMissingFromResponse(fetchResponse) {
                this.element.setAttribute("complete", "");
                var response = fetchResponse.response;
                var _this = this;
                var _$visit = function() {
                    var _ref = (0, $jpnpo._)(function(url) {
                        var options;
                        var _arguments = arguments;
                        return (0, $itJXR.__generator)(this, function(_state) {
                            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                            if (url instanceof Response) _this.visitResponse(url);
                            else session.visit(url, options);
                            return [
                                2
                            ];
                        });
                    });
                    return function _$visit(url) {
                        return _ref.apply(this, arguments);
                    };
                }();
                var event = dispatch("turbo:frame-missing", {
                    target: this.element,
                    detail: {
                        response: response,
                        visit: _$visit
                    },
                    cancelable: true
                });
                return !event.defaultPrevented;
            }
        },
        {
            key: "handleFrameMissingFromResponse",
            value: function handleFrameMissingFromResponse(fetchResponse) {
                this.view.missing();
                this.throwFrameMissingError(fetchResponse);
            }
        },
        {
            key: "throwFrameMissingError",
            value: function throwFrameMissingError(fetchResponse) {
                var message = "The response (".concat(fetchResponse.statusCode, ') did not contain the expected <turbo-frame id="').concat(this.element.id, '"> and will be ignored. To perform a full page visit instead, set turbo-visit-control to reload.');
                throw new TurboFrameMissingError(message);
            }
        },
        {
            key: "visitResponse",
            value: function visitResponse(response) {
                return (0, $jpnpo._)(function() {
                    var wrapped, responseHTML, location1, redirected, statusCode;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                wrapped = new FetchResponse(response);
                                return [
                                    4,
                                    wrapped.responseHTML
                                ];
                            case 1:
                                responseHTML = _state.sent();
                                location1 = wrapped.location, redirected = wrapped.redirected, statusCode = wrapped.statusCode;
                                return [
                                    2,
                                    session.visit(location1, {
                                        response: {
                                            redirected: redirected,
                                            statusCode: statusCode,
                                            responseHTML: responseHTML
                                        }
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "findFrameElement",
            value: function findFrameElement(element, submitter) {
                var _a;
                var id = getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
                return (_a = getFrameElementById(id)) !== null && _a !== void 0 ? _a : this.element;
            }
        },
        {
            key: "extractForeignFrameElement",
            value: function extractForeignFrameElement(container) {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var element, id, error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                id = CSS.escape(_this.id);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]);
                                element = activateElement(container.querySelector("turbo-frame#".concat(id)), _this.sourceURL);
                                if (element) return [
                                    2,
                                    element
                                ];
                                element = activateElement(container.querySelector("turbo-frame[src][recurse~=".concat(id, "]")), _this.sourceURL);
                                if (!element) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    element.loaded
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    _this.extractForeignFrameElement(element)
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                error = _state.sent();
                                console.error(error);
                                return [
                                    2,
                                    new FrameElement()
                                ];
                            case 6:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "formActionIsVisitable",
            value: function formActionIsVisitable(form, submitter) {
                var action = getAction(form, submitter);
                return locationIsVisitable(expandURL(action), this.rootLocation);
            }
        },
        {
            key: "shouldInterceptNavigation",
            value: function shouldInterceptNavigation(element, submitter) {
                var id = getAttribute("data-turbo-frame", submitter, element) || this.element.getAttribute("target");
                if (element instanceof HTMLFormElement && !this.formActionIsVisitable(element, submitter)) return false;
                if (!this.enabled || id == "_top") return false;
                if (id) {
                    var frameElement = getFrameElementById(id);
                    if (frameElement) return !frameElement.disabled;
                }
                if (!session.elementIsNavigatable(element)) return false;
                if (submitter && !session.elementIsNavigatable(submitter)) return false;
                return true;
            }
        },
        {
            key: "id",
            get: function get() {
                return this.element.id;
            }
        },
        {
            key: "enabled",
            get: function get() {
                return !this.element.disabled;
            }
        },
        {
            key: "sourceURL",
            get: function get() {
                if (this.element.src) return this.element.src;
            },
            set: function set(sourceURL) {
                var _this = this;
                this.ignoringChangesToAttribute("src", function() {
                    _this.element.src = sourceURL !== null && sourceURL !== void 0 ? sourceURL : null;
                });
            }
        },
        {
            key: "loadingStyle",
            get: function get() {
                return this.element.loading;
            }
        },
        {
            key: "isLoading",
            get: function get() {
                return this.formSubmission !== undefined || this.resolveVisitPromise() !== undefined;
            }
        },
        {
            key: "complete",
            get: function get() {
                return this.element.hasAttribute("complete");
            },
            set: function set(value) {
                var _this = this;
                this.ignoringChangesToAttribute("complete", function() {
                    if (value) _this.element.setAttribute("complete", "");
                    else _this.element.removeAttribute("complete");
                });
            }
        },
        {
            key: "isActive",
            get: function get() {
                return this.element.isActive && this.connected;
            }
        },
        {
            key: "rootLocation",
            get: function get() {
                var _a;
                var meta = this.element.ownerDocument.querySelector('meta[name="turbo-root"]');
                var root = (_a = meta === null || meta === void 0 ? void 0 : meta.content) !== null && _a !== void 0 ? _a : "/";
                return expandURL(root);
            }
        },
        {
            key: "isIgnoringChangesTo",
            value: function isIgnoringChangesTo(attributeName) {
                return this.ignoredAttributes.has(attributeName);
            }
        },
        {
            key: "ignoringChangesToAttribute",
            value: function ignoringChangesToAttribute(attributeName, callback) {
                this.ignoredAttributes.add(attributeName);
                callback();
                this.ignoredAttributes.delete(attributeName);
            }
        },
        {
            key: "withCurrentNavigationElement",
            value: function withCurrentNavigationElement(element, callback) {
                this.currentNavigationElement = element;
                callback();
                delete this.currentNavigationElement;
            }
        }
    ]);
    return FrameController;
}();
function getFrameElementById(id) {
    if (id != null) {
        var element = document.getElementById(id);
        if (element instanceof FrameElement) return element;
    }
}
function activateElement(element, currentURL) {
    if (element) {
        var src = element.getAttribute("src");
        if (src != null && currentURL != null && urlsAreEqual(src, currentURL)) throw new Error('Matching <turbo-frame id="'.concat(element.id, '"> element has a source URL which references itself'));
        if (element.ownerDocument !== document) element = document.importNode(element, true);
        if (element instanceof FrameElement) {
            element.connectedCallback();
            element.disconnectedCallback();
            return element;
        }
    }
}
var StreamElement = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $i0LXg._)(StreamElement, HTMLElement1);
    var _super = (0, $a1vXf._)(StreamElement);
    function StreamElement() {
        (0, $9j09T._)(this, StreamElement);
        return _super.apply(this, arguments);
    }
    (0, $eDeHT._)(StreamElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var error;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.render()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                error = _state.sent();
                                console.error(error);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.disconnect();
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return (0, $jpnpo._)(function() {
                    var _a;
                    return (0, $itJXR.__generator)(this, function(_state) {
                        return [
                            2,
                            (_a = _this.renderPromise) !== null && _a !== void 0 ? _a : _this.renderPromise = (0, $jpnpo._)(function() {
                                var event;
                                return (0, $itJXR.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            event = _this.beforeRenderEvent;
                                            if (!_this.dispatchEvent(event)) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                nextAnimationFrame()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                event.detail.render(_this)
                                            ];
                                        case 2:
                                            _state.sent();
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })()
                        ];
                    });
                })();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                try {
                    this.remove();
                } catch (_a) {}
            }
        },
        {
            key: "removeDuplicateTargetChildren",
            value: function removeDuplicateTargetChildren() {
                this.duplicateChildren.forEach(function(c) {
                    return c.remove();
                });
            }
        },
        {
            key: "duplicateChildren",
            get: function get() {
                var _a;
                var existingChildren = this.targetElements.flatMap(function(e) {
                    return (0, $enL5v._)(e.children);
                }).filter(function(c) {
                    return !!c.id;
                });
                var newChildrenIds = (0, $enL5v._)(((_a = this.templateContent) === null || _a === void 0 ? void 0 : _a.children) || []).filter(function(c) {
                    return !!c.id;
                }).map(function(c) {
                    return c.id;
                });
                return existingChildren.filter(function(c) {
                    return newChildrenIds.includes(c.id);
                });
            }
        },
        {
            key: "performAction",
            get: function get() {
                if (this.action) {
                    var actionFunction = StreamActions[this.action];
                    if (actionFunction) return actionFunction;
                    this.raise("unknown action");
                }
                this.raise("action attribute is missing");
            }
        },
        {
            key: "targetElements",
            get: function get() {
                if (this.target) return this.targetElementsById;
                else if (this.targets) return this.targetElementsByQuery;
                else this.raise("target or targets attribute is missing");
            }
        },
        {
            key: "templateContent",
            get: function get() {
                return this.templateElement.content.cloneNode(true);
            }
        },
        {
            key: "templateElement",
            get: function get() {
                if (this.firstElementChild === null) {
                    var template = this.ownerDocument.createElement("template");
                    this.appendChild(template);
                    return template;
                } else if (this.firstElementChild instanceof HTMLTemplateElement) return this.firstElementChild;
                this.raise("first child element must be a <template> element");
            }
        },
        {
            key: "action",
            get: function get() {
                return this.getAttribute("action");
            }
        },
        {
            key: "target",
            get: function get() {
                return this.getAttribute("target");
            }
        },
        {
            key: "targets",
            get: function get() {
                return this.getAttribute("targets");
            }
        },
        {
            key: "raise",
            value: function raise(message) {
                throw new Error("".concat(this.description, ": ").concat(message));
            }
        },
        {
            key: "description",
            get: function get() {
                var _a, _b;
                return (_b = ((_a = this.outerHTML.match(/<[^>]+>/)) !== null && _a !== void 0 ? _a : [])[0]) !== null && _b !== void 0 ? _b : "<turbo-stream>";
            }
        },
        {
            key: "beforeRenderEvent",
            get: function get() {
                return new CustomEvent("turbo:before-stream-render", {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        newStream: this,
                        render: StreamElement.renderElement
                    }
                });
            }
        },
        {
            key: "targetElementsById",
            get: function get() {
                var _a;
                var element = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.getElementById(this.target);
                if (element !== null) return [
                    element
                ];
                else return [];
            }
        },
        {
            key: "targetElementsByQuery",
            get: function get() {
                var _a;
                var elements = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.querySelectorAll(this.targets);
                if (elements.length !== 0) return Array.prototype.slice.call(elements);
                else return [];
            }
        }
    ], [
        {
            key: "renderElement",
            value: function renderElement(newElement) {
                return (0, $jpnpo._)(function() {
                    return (0, $itJXR.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    newElement.performAction()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return StreamElement;
}((0, $fYvNR._)(HTMLElement));
var StreamSourceElement = /*#__PURE__*/ function(HTMLElement1) {
    "use strict";
    (0, $i0LXg._)(StreamSourceElement, HTMLElement1);
    var _super = (0, $a1vXf._)(StreamSourceElement);
    function StreamSourceElement() {
        (0, $9j09T._)(this, StreamSourceElement);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.streamSource = null;
        return _this;
    }
    (0, $eDeHT._)(StreamSourceElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                this.streamSource = this.src.match(/^ws{1,2}:/) ? new WebSocket(this.src) : new EventSource(this.src);
                connectStreamSource(this.streamSource);
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                if (this.streamSource) disconnectStreamSource(this.streamSource);
            }
        },
        {
            key: "src",
            get: function get() {
                return this.getAttribute("src") || "";
            }
        }
    ]);
    return StreamSourceElement;
}((0, $fYvNR._)(HTMLElement));
FrameElement.delegateConstructor = FrameController;
if (customElements.get("turbo-frame") === undefined) customElements.define("turbo-frame", FrameElement);
if (customElements.get("turbo-stream") === undefined) customElements.define("turbo-stream", StreamElement);
if (customElements.get("turbo-stream-source") === undefined) customElements.define("turbo-stream-source", StreamSourceElement);
(function() {
    var element = document.currentScript;
    if (!element) return;
    if (element.hasAttribute("data-turbo-suppress-warning")) return;
    element = element.parentElement;
    while(element){
        if (element == document.body) return console.warn(unindent(_templateObject1()), element.outerHTML);
        element = element.parentElement;
    }
})();
window.Turbo = Turbo;
start();

});
parcelRegister("feAea", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $b17443da2844f209$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $b17443da2844f209$export$f3b8ed2e4a5d10b8; });
function $b17443da2844f209$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("jpnpo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e212828f6cfa42b8$export$7c398597f8905a1; });
function $e212828f6cfa42b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $e212828f6cfa42b8$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $e212828f6cfa42b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $e212828f6cfa42b8$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("9j09T", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c6602e55f68dee2$export$2996f80ef42b8419; });
function $6c6602e55f68dee2$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eDeHT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aa701db5d47dce88$export$d60067ff2358eee8; });
function $aa701db5d47dce88$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aa701db5d47dce88$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $aa701db5d47dce88$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa701db5d47dce88$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("Npnks", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $094842b801526c9c$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $094842b801526c9c$export$1e71eb4bef00f6b0; });
function $094842b801526c9c$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("15W2b", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0cc34673f915cde4$export$afb3516d9d608401; });

var $kTflC = parcelRequire("kTflC");
function $0cc34673f915cde4$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $0cc34673f915cde4$export$afb3516d9d608401 = Reflect.get;
    else $0cc34673f915cde4$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $kTflC._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $0cc34673f915cde4$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRegister("kTflC", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $f354d96db1b059b8$export$e4187255aefbc259; });

var $711He = parcelRequire("711He");
function $f354d96db1b059b8$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $711He._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});
parcelRegister("711He", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $51b9f13c9445541e$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $51b9f13c9445541e$export$f09211a7d3c496a1; });
function $51b9f13c9445541e$export$f09211a7d3c496a1(o) {
    $51b9f13c9445541e$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $51b9f13c9445541e$export$f09211a7d3c496a1(o);
}

});



parcelRegister("i0LXg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d1cd6ce56362f439$export$7e4530ad35d3bb8; });

var $9DCaq = parcelRequire("9DCaq");
function $d1cd6ce56362f439$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $9DCaq._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("9DCaq", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $70455ccaac1047d2$export$c2c98ac76e997b63; });
function $70455ccaac1047d2$export$c2c98ac76e997b63(o, p) {
    $70455ccaac1047d2$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $70455ccaac1047d2$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("fyOZQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b54196d937983a6a$export$fdf2a89c76341bbf; });

var $xoQEU = parcelRequire("xoQEU");

var $cSId0 = parcelRequire("cSId0");

var $goXgb = parcelRequire("goXgb");

var $2FuLA = parcelRequire("2FuLA");
function $b54196d937983a6a$export$fdf2a89c76341bbf(arr, i) {
    return (0, $xoQEU._array_with_holes)(arr) || (0, $cSId0._iterable_to_array_limit)(arr, i) || (0, $2FuLA._unsupported_iterable_to_array)(arr, i) || (0, $goXgb._non_iterable_rest)();
}

});
parcelRegister("xoQEU", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $06465b8b4b6a3b50$export$e6256bf45c68d561; });
function $06465b8b4b6a3b50$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("cSId0", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $960cd22355c3e394$export$2fd15edff6687200; });
function $960cd22355c3e394$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("goXgb", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $bf0cdb0f645955fa$export$60dbc22abd7da546; });
function $bf0cdb0f645955fa$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("2FuLA", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $1f1746ac73a3230e$export$a5be06335b3a083c; });

var $9iKib = parcelRequire("9iKib");
function $1f1746ac73a3230e$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $9iKib._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $9iKib._array_like_to_array)(o, minLen);
}

});
parcelRegister("9iKib", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $6c59b4326a243df3$export$79e617b1955a2616; });
function $6c59b4326a243df3$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("aqIdE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $797ea21c561234db$export$263b15b19e6ed8f; });
function $797ea21c561234db$export$263b15b19e6ed8f(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("enL5v", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a787bd51e8929c56$export$1b5e630bc3aea29f; });

var $iDrRq = parcelRequire("iDrRq");

var $jEB8U = parcelRequire("jEB8U");

var $hlS7H = parcelRequire("hlS7H");

var $2FuLA = parcelRequire("2FuLA");
function $a787bd51e8929c56$export$1b5e630bc3aea29f(arr) {
    return (0, $iDrRq._array_without_holes)(arr) || (0, $jEB8U._iterable_to_array)(arr) || (0, $2FuLA._unsupported_iterable_to_array)(arr) || (0, $hlS7H._non_iterable_spread)();
}

});
parcelRegister("iDrRq", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $d9117b172aac03e6$export$7e0947b5ad3404e2; });

var $9iKib = parcelRequire("9iKib");
function $d9117b172aac03e6$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $9iKib._array_like_to_array)(arr);
}

});

parcelRegister("jEB8U", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $e4ee9089a26da374$export$1eb58a6e75231000; });
function $e4ee9089a26da374$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("hlS7H", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $ca1e618e406bc232$export$e6f3c4780d19eb2b; });
function $ca1e618e406bc232$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fYvNR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ba1521109d958cd4$export$2466d533fda16e33; });

var $vX6fQ = parcelRequire("vX6fQ");

var $711He = parcelRequire("711He");

var $9NW8H = parcelRequire("9NW8H");

var $9DCaq = parcelRequire("9DCaq");
function $ba1521109d958cd4$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $ba1521109d958cd4$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $9NW8H._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $vX6fQ._construct)(Class, arguments, (0, $711He._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $9DCaq._set_prototype_of)(Wrapper, Class);
    };
    return $ba1521109d958cd4$export$2466d533fda16e33(Class);
}

});
parcelRegister("vX6fQ", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $0600bd5ed8b1bd3f$export$2d841144c5f8c4ab; });

var $27Mer = parcelRequire("27Mer");

var $9DCaq = parcelRequire("9DCaq");
function $0600bd5ed8b1bd3f$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $27Mer._is_native_reflect_construct)()) $0600bd5ed8b1bd3f$export$2d841144c5f8c4ab = Reflect.construct;
    else $0600bd5ed8b1bd3f$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $9DCaq._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $0600bd5ed8b1bd3f$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRegister("27Mer", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $18c1a60db59ef4aa$export$685354647fba1516; });
function $18c1a60db59ef4aa$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("9NW8H", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $7235c9e75436b16d$export$514eda94019f4334; });
function $7235c9e75436b16d$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("a1vXf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $74c2c8e9df4e1d63$export$8dd05c13f5255580; });

var $711He = parcelRequire("711He");

var $27Mer = parcelRequire("27Mer");

var $McFnd = parcelRequire("McFnd");
function $74c2c8e9df4e1d63$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $27Mer._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $711He._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $711He._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $McFnd._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("McFnd", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $090e4f134975518e$export$ef97c660ca164e52; });

var $feAea = parcelRequire("feAea");

var $jquDQ = parcelRequire("jquDQ");
function $090e4f134975518e$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $jquDQ._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $feAea._assert_this_initialized)(self);
}

});
parcelRegister("jquDQ", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $e24836d14c634a24$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $e24836d14c634a24$export$5f0017c582d45a2d; });
function $e24836d14c634a24$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("itJXR", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $d73e97026d3946cf$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $d73e97026d3946cf$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $jquDQ = parcelRequire("jquDQ");
var $d73e97026d3946cf$var$extendStatics = function extendStatics1(d, b) {
    $d73e97026d3946cf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $d73e97026d3946cf$var$extendStatics(d, b);
};
function $d73e97026d3946cf$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $d73e97026d3946cf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $d73e97026d3946cf$export$18ce0697a983be9b = function __assign1() {
    $d73e97026d3946cf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d73e97026d3946cf$export$18ce0697a983be9b.apply(this, arguments);
};
function $d73e97026d3946cf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $d73e97026d3946cf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $d73e97026d3946cf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $d73e97026d3946cf$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $d73e97026d3946cf$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $d73e97026d3946cf$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $jquDQ._)(x)) === "symbol" ? x : "".concat(x);
}
function $d73e97026d3946cf$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $jquDQ._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $d73e97026d3946cf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $d73e97026d3946cf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $d73e97026d3946cf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $d73e97026d3946cf$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $d73e97026d3946cf$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $d73e97026d3946cf$export$45d3717a4c69092e(o, m, p);
}
function $d73e97026d3946cf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $d73e97026d3946cf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $d73e97026d3946cf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($d73e97026d3946cf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $d73e97026d3946cf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $d73e97026d3946cf$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $d73e97026d3946cf$export$10c90e4f7922046c(v) {
    return this instanceof $d73e97026d3946cf$export$10c90e4f7922046c ? (this.v = v, this) : new $d73e97026d3946cf$export$10c90e4f7922046c(v);
}
function $d73e97026d3946cf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $d73e97026d3946cf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $d73e97026d3946cf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $d73e97026d3946cf$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $d73e97026d3946cf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $d73e97026d3946cf$export$19a8beecd37a4c45 === "function" ? $d73e97026d3946cf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $d73e97026d3946cf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $d73e97026d3946cf$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $d73e97026d3946cf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d73e97026d3946cf$export$45d3717a4c69092e(result, mod, k);
    }
    $d73e97026d3946cf$var$__setModuleDefault(result, mod);
    return result;
}
function $d73e97026d3946cf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $d73e97026d3946cf$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $d73e97026d3946cf$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $d73e97026d3946cf$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $d73e97026d3946cf$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $d73e97026d3946cf$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $d73e97026d3946cf$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $d73e97026d3946cf$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $d73e97026d3946cf$export$2e2bcd8739ae039 = {
    __extends: $d73e97026d3946cf$export$a8ba968b8961cb8a,
    __assign: $d73e97026d3946cf$export$18ce0697a983be9b,
    __rest: $d73e97026d3946cf$export$3c9a16f847548506,
    __decorate: $d73e97026d3946cf$export$29e00dfd3077644b,
    __param: $d73e97026d3946cf$export$d5ad3fd78186038f,
    __metadata: $d73e97026d3946cf$export$f1db080c865becb9,
    __awaiter: $d73e97026d3946cf$export$1050f835b63b671e,
    __generator: $d73e97026d3946cf$export$67ebef60e6f28a6,
    __createBinding: $d73e97026d3946cf$export$45d3717a4c69092e,
    __exportStar: $d73e97026d3946cf$export$f33643c0debef087,
    __values: $d73e97026d3946cf$export$19a8beecd37a4c45,
    __read: $d73e97026d3946cf$export$8d051b38c9118094,
    __spread: $d73e97026d3946cf$export$afc72e2116322959,
    __spreadArrays: $d73e97026d3946cf$export$6388937ca91ccae8,
    __spreadArray: $d73e97026d3946cf$export$1216008129fb82ed,
    __await: $d73e97026d3946cf$export$10c90e4f7922046c,
    __asyncGenerator: $d73e97026d3946cf$export$e427f37a30a4de9b,
    __asyncDelegator: $d73e97026d3946cf$export$bbd80228419bb833,
    __asyncValues: $d73e97026d3946cf$export$e3b29a3d6162315f,
    __makeTemplateObject: $d73e97026d3946cf$export$4fb47efe1390b86f,
    __importStar: $d73e97026d3946cf$export$c21735bcef00d192,
    __importDefault: $d73e97026d3946cf$export$da59b14a69baef04,
    __classPrivateFieldGet: $d73e97026d3946cf$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $d73e97026d3946cf$export$d40a35129aaff81f,
    __classPrivateFieldIn: $d73e97026d3946cf$export$81fdc39f203e4e04,
    __addDisposableResource: $d73e97026d3946cf$export$88ac25d8e944e405,
    __disposeResources: $d73e97026d3946cf$export$8f076105dc360e92
};

});


})();
//# sourceMappingURL=turbo-classic.01398792.js.map
